'use strict';

angular.module('mean.accounting').controller('ReportsController',
     ['$scope', '$http', '$filter', '$timeout', 'Global', 'MeanUser', 'aceUtils', 'Users', 'userService', 'Charts', 'ngDialog', 'commonConstant', 'TransactionService', 'tradeCodeService', 'Trades',  'accountingConstant',
     function ($scope, $http, $filter, $timeout, Global, MeanUser, aceUtils, Users, userService, Charts, ngDialog, commonConstant, TransactionService, tradeCodeService, Trades,  accountingConstant) {
        $scope.global = Global;
        $scope.user = MeanUser.user;
        $scope.senderEmail = [];
        $scope.showTestText = false;
        $scope.accountingConstant = accountingConstant;
        $scope.commonConstant = commonConstant;
        var reportConstant = accountingConstant.reportConstant,
            generalLedger = reportConstant.generalLedger,
            balanceSheet = reportConstant.balanceSheet,
            incomeStatus = reportConstant.incomeStatus,
            workProcess = reportConstant.workProcess;
        $scope.detailTypes = angular.copy(accountingConstant.balanceTypes);
        $scope.balanceSheets = angular.copy(accountingConstant.balanceSheets);
        $scope.incomeTypes = angular.copy(accountingConstant.incomeTypes);
        $scope.incomeSheets = angular.copy(accountingConstant.incomeSheets);
        $scope.main_accountId = '';
        $scope.users_trade_account = {};
        $scope.selectedTabs = generalLedger;
        $scope.strFormat = 'MMM DD YYYY';
        $scope.payperiods = [];
        $scope.rangeOption = [
            { label:'This Year to Date', dateRange: [moment().startOf('year'), moment().endOf('day')]},
            { label:'This Year', dateRange: [moment().startOf('year'), moment().endOf('year')]},
            { label:'This Quarter to Date', dateRange: [moment().startOf('quarter'), moment().endOf('day')]},
            { label:'This Quarter', dateRange: [moment().startOf('quarter'), moment().endOf('quarter')]},
            { label:'This Month to Date', dateRange: [moment().startOf('month'), moment().endOf('day')]},
            { label:'This Month', dateRange: [moment().startOf('month'), moment().endOf('month')]},
            { label:'This Week to Date', dateRange: [moment().startOf('week'), moment().endOf('day')]},
            { label:'This Week', dateRange: [moment().startOf('week'), moment().endOf('week')]},
            { label: 'Today', dateRange: [moment().startOf('day'), moment().endOf('day')]},
            { label: 'Custom', dateRange: []}
        ]
        $scope.selFilter = {
            columnData: 'Totals Only',
            changeAs: 'None',
            compareTo: 'None',
            selRange: $scope.rangeOption[0]
        };
        $scope.totalExpenseAmount = 0;
        $scope.startDate = moment().startOf('year').toDate();
        $scope.endDate = moment().endOf('day').toDate();
        $scope.accountsList = [];
        $scope.accountsBalances = [];
        $scope.transactionType = 'Accrual';
        $scope.isFetchedReport = false;
        $scope.companyName = '';
        $scope.columnDates = [];
        $scope.compareDates = [];
        $scope.selectedRange =  moment().startOf('year').format('MM/DD/YYYY') + ' - ' + moment().endOf('day').format('MM/DD/YYYY');;
        $scope.showRangeOption = false;
        $scope.columnDataShown = [
            'Totals Only',
            'Totals and % of total',
            'Weeks (Totals Only)',
            'Weeks (Totals & %)',
            'Months (Totals Only)',
            'Months (Totals & %)',
            'Quarters (Total Only)',
            'Quarters (Totals & %)'
        ];
        $scope.compareTo = [
            'None',
            'Previous Period',
            'Previous Year',
            'Year-to-Date'
        ];
        $scope.changeAs = [
            'None',
            '$ Change',
            '% Change',
            '$ & % Change'
        ]
        $scope.reportDateRange = { startDate: null, endDate: null};
        $scope.reportRangeOptions = {
            locale: { format: "MM/DD/YYYY" },
            separator: ' - ',
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': function(ev, picker) {
                    const dateObje = angular.copy(ev.model);
                    $scope.dateRangeUpdated([dateObje.startDate, dateObje.endDate]);
                }
            }
        };
        $scope.accountMethod = 'Accrual';
        $scope.rowSelection = 'All';
        $scope.columnSelection = 'All';
        var removeIndex = [],
        balanceSheetChartList;
        $scope.printToCart = function(printSectionID) {
            // get the content of html element that you want to print
            var innerContents = document.getElementById(printSectionID).innerHTML;
            // open a popup window to draw your html
            var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            // embed your css file and CDN css file into head, embed html content into body
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /><link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
        }

        $scope.generalLedgerHeadings = [
            { text: 'Account Name', bold: true },
            { text: 'Date', bold: true },
            { text: 'Transaction Type', bold: true },
            { text: 'Name', bold: true },
            { text: 'Reference', bold: true },
            { text: 'Memo', bold: true },
            { text: 'Split', bold: true },
            { text: 'Amount', bold: true },
            { text: 'Balance', bold: true }
        ];

        $scope.generalLedgerHeadingsCSV = [ 'Account Name', 'Date', 'Transaction Type', 'Name', 'Reference', 'Memo', 'Split', 'Amount', 'Balance'];

        $scope.init = function () {
            userService.getMainAccountId($scope.user.username).then(function(id) {
                $scope.main_accountId = id;
                Trades.query({ 'main_account_id': $scope.main_accountId }, function (trade) {
                    $scope.users_trade_account = trade[0];
                    trade[0].company_code = aceUtils.padDigits(trade[0].company_code, 3);
                    trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
                    userService.getCompanyName($scope.user.username).then(function(company) {
                        $scope.companyName = company;
                        $scope.getAllChartAct()
                        Users.query({
                            'username': $scope.user.username,
                        }, function (users) {
                            $scope.fiscalYear = moment(users[0].fiscalYear);
                        })
                    });
                });
            });
        };
        $scope.getAllChartAct = () => {
            var chartQuery = { type: 'All', isDeleted: false, userId: $scope.clientAccountId };
            Charts.query(chartQuery, function (accounts) {
                $scope.allAccounts = accounts;
                $scope.accountsList = getAccountList(accounts);
                $scope.glAccountsList = $filter('orderBy')($scope.accountsList, ['name']);
                $scope.accountsListSelection = $scope.glAccountsList[0];
                balanceSheetChartList = _.groupBy($scope.accountsList, 'accountType');
            });
        }

        $scope.combineByName = function(reportTrans) {
            var text = '';
            if(reportTrans.length === 1) {
                text = reportTrans[0]['name'] ? reportTrans[0]['name'] : '';
            } else if(Array.isArray(reportTrans) && reportTrans.length) {
                var newArray = angular.copy(reportTrans);
                var uniqueExp = _.uniqBy(newArray, 'name');
                if(uniqueExp.length > 1) {
                    text = 'Account Split';
                } else {
                    text = reportTrans.length ? reportTrans[0]['name'] ?
                            reportTrans[0]['name']: '' : '' ;
                }
            }
            return text;
        }

        $scope.changeCompareTo = function(data) {
            $scope.selFilter.compareTo = data;
        }
        $scope.changeColumnData = function(data){
            $scope.selFilter.columnData = data;
        }

        $scope.changeShowAsTo = function(data) {
            $scope.selFilter.changeAs = data;
        }

        $scope.changeSelection = function() { 
            if($scope.selFilter.selRange.dateRange.length > 0) {
                $scope.showRangeOption = false;
                $scope.selectedRange = moment($scope.selFilter.selRange.dateRange[0]).format('MM/DD/YYYY') + ' - ' + moment($scope.selFilter.selRange.dateRange[1]).format('MM/DD/YYYY');
                $scope.dateRangeUpdated($scope.selFilter.selRange.dateRange);
            } else {
                $scope.showRangeOption = true;
            }
        }
        $scope.dateRangeUpdated = function (ranges) {
            if (!ranges.length) return;
    
            $scope.startDate = new Date(ranges[0]);
            $scope.endDate = new Date(ranges[1]);
    
            $scope.startDate.setHours(0);
            $scope.startDate.setMinutes(0);
            $scope.startDate.setSeconds(0);
            $scope.endDate.setHours(23);
            $scope.endDate.setMinutes(59);
            $scope.endDate.setSeconds(59);
        };

        $scope.changeAccountMethod = function(state) {
            $scope.accountMethod = state;
        }

        $scope.changeRowMethod = function(state) {
            $scope.rowSelection = state;
        }

        $scope.changeColumnMethod = function(state) {
            $scope.columnSelection = state;
        }

        $scope.changeAccountSelection = function(state) {
            $scope.accountsListSelection = state;
        }
        var accountType = accountingConstant.accountType;
        
        /**
         * @description general Ledger Report
         */
        $scope.setGeneralLedgerReport = function() {
            $scope.isFetchedReport = true;
            let searchProperties = {
                clientAccountId: $scope.main_accountId,
                name: $scope.accountsListSelection.name,
                type: 'searchReport',
                reportType: generalLedger,
                accountMethod: $scope.accountMethod
            };
            TransactionService.query(searchProperties, function (transaction) {
                var sortedAccount = sortAccountWithParentType(transaction);
                var accountsList = sortedAccount.map(function(item){
                    var reportObj = {};
                    reportObj.id = item._id;
                    reportObj.name = item.name;
                    var debitAccountIncrease = (accountType[0].name === item.parentOfAccountType)
                        || (accountType[0].name === item.parentOfParentAccountType)
                        || (accountType[4].name === item.parentOfAccountType)
                        || (accountType[4].name === item.parentOfParentAccountType);

                    reportObj.date = item.createdDate;
                    var allTransaction = item.transactions.map( function(item){
                        return item.transaction;
                    });
                    var sortedTransaction = _.sortBy(allTransaction, function(dateObj) {
                        return new Date(dateObj.date);
                    });

                    var chartBeforeDateTransaction = sortedTransaction.filter(function(item){
                        return moment(item.date).isBefore($scope.startDate);
                    })
                    reportObj.transactions = sortedTransaction.filter(function(item){
                        return (moment(item.date).isAfter($scope.startDate) || moment(item.date).isSame($scope.startDate)) &&  (moment(item.date).isBefore($scope.endDate) || moment(item.date).isSame($scope.endDate));
                    })
                    var beforebalance = 0;
                    for ( var item of chartBeforeDateTransaction) {
                        var debitAmount = 0, creditAmount = 0;
                        // payment account mean credit account
                        var payment = item.paymentAccounts.filter(function(item){
                            return item.paymentAccount == reportObj.id;
                        })
                        if (payment.length) {
                            var debitAmount = payment.reduce(function(p, c){
                                return Number(p) + Number(c.paymentAmount)
                            }, 0)
                        } else {
                            // expense account means debit account
                            var expense = item.expense.filter(function(item) {
                                return item.expenseAccount == reportObj.id;
                            })
                            if (expense) {
                                var creditAmount = expense.reduce(function(p, c){
                                    return Number(p) + Number(c.expenseAmount)
                                }, 0)
                            }
                        }
                        beforebalance = debitAccountIncrease ?  Number(beforebalance) + Number(debitAmount) - Number(creditAmount) :
                            Number(beforebalance) - Number(debitAmount) + Number(creditAmount);
                    }
                    reportObj.openingBalance = Number(beforebalance);
                    var totalAmount = 0;
                    var balance = Number(beforebalance);
                    for ( var item of reportObj.transactions) {
                        //credit account
                        var payment = item.paymentAccounts.filter(function(item){
                            return item.paymentAccount == reportObj.id;
                        })
                        if (payment.length) {
                            var creditAmount = payment.reduce(function(p, c){
                                return Number(p) + Number(c.paymentAmount)
                            }, 0)
                            item.transactionReport = item.expense;
                            item.amount = debitAccountIncrease ? -Number(creditAmount): Number(creditAmount);
                            balance =  debitAccountIncrease ? Number(balance) - Number(creditAmount) : Number(balance) + Number(creditAmount);
                            item.balance = balance;
                            totalAmount = debitAccountIncrease ? totalAmount - Number(creditAmount): totalAmount + Number(creditAmount);
                        } else {
                            //debit account
                            var expense = item.expense.filter(function(item) {
                                return item.expenseAccount == reportObj.id;
                            })
                            if (expense) {
                                var debitAmount = expense.reduce(function(p, c){
                                    return Number(p) + Number(c.expenseAmount)
                                }, 0)
                                item.transactionReport = item.paymentAccounts;
                                item.amount = debitAccountIncrease ? Number(debitAmount) : -Number(debitAmount);
                                balance =  debitAccountIncrease ? Number(balance) + Number(debitAmount) : Number(balance) - Number(debitAmount);
                                item.balance = balance
                                totalAmount = debitAccountIncrease ? totalAmount + Number(debitAmount): totalAmount - Number(debitAmount)
                            }
                        }
                    }
                    reportObj.totalBalance = balance;
                    reportObj.totalAmount = totalAmount;
                    return reportObj
                });
                $scope.accountsList = accountsList.filter(function(item){return item.transactions.length});
                $scope.showSpinner = false;
            });

        }

        /**
         * @description Sort account on the basis of parent Type
         * @param {object} transaction 
         */
        function sortAccountWithParentType (transaction) {
            var sortedAccountTransaction = [];
            accountingConstant.accountType.map(function(item){

                var filterTransaction = transaction.filter(function(transItem) {
                    return item.name === transItem.parentOfAccountType || item.name === transItem.parentOfParentAccountType;
                })
                filterTransaction = _.sortBy(filterTransaction, ['name']);

                sortedAccountTransaction = sortedAccountTransaction.concat(filterTransaction);
            })
            return sortedAccountTransaction;
        }

        $scope.getTotalPercentage = function (startDate, endDate, percentage, compareToDate, changeShowAs, selFilter) {
            return totalPercentage(startDate, endDate, percentage, compareToDate, changeShowAs, selFilter);
        }

        $scope.getWeekRange = function (startDate, endDate, index, count, ranges, columnCount, compare, showAs, perc, comOption) {
            return weekRange(startDate, endDate, index, count, ranges, columnCount, compare, showAs, perc, comOption);
        }

        $scope.getMonthRange = function (startDate, endDate, index, count, ranges, firstMonth, columnCount, compare, showAs, perc, comOption) {
           return monthRange(startDate, endDate, index, count, ranges, firstMonth, columnCount, compare, showAs, perc, comOption);
        }
        
        $scope.getQuarterRange = function (startDate, endDate, index, count, ranges, firstMonth, columnCount, compare, showAs, perc, comOption) {
            return quarterRange(startDate, endDate, index, count, ranges, firstMonth, columnCount, compare, showAs, perc, comOption);
        }

        $scope.toggleRow = function(data) {
            if (data.hasOwnProperty('expended')){
                data['expended'] = !data['expended'];
                if (data.hasOwnProperty('childs') && data.childs.length) {
                    data.childs.map(function(item) {
                        if (item.hasOwnProperty('expended')){
                            item.expended = !!item.expended ? false : item.expended
                            if (item.types.length) {
                                item.types.map(function(sub){
                                    if (sub.hasOwnProperty('expended')){
                                        sub.expended = !!sub.expended ? false : sub.expended;
                                    }
                                    if(sub.hasOwnProperty('types') && sub.types.length) {
                                        sub.types.map(function(subChild){
                                            if (subChild.hasOwnProperty('expended')){
                                                subChild.expended = !!subChild.expended ? false : subChild.expended;
                                            }
                                            if (subChild.hasOwnProperty('charts') && !!subChild.charts && subChild.charts.length) {
                                                subChild.charts.map(function(chart1){
                                                    if (chart1.hasOwnProperty('expended')){
                                                        chart1.expended = !!chart1.expended ? false : chart1.expended;
                                                    }
                                                    if (chart1.hasOwnProperty('childItem') && chart1.childItem.length) {
                                                        chart1.childItem.map(function(chart2){
                                                            if (chart2.hasOwnProperty('expended')){
                                                                chart2.expended = !!chart2.expended ? false : chart2.expended;
                                                            }
                                                            if (chart2.hasOwnProperty('childItem') && chart2.childItem.length) {
                                                                chart2.childItem.map(function(chart3){
                                                                    if (chart3.hasOwnProperty('expended')){
                                                                        chart3.expended = !!chart3.expended ? false : chart3.expended;
                                                                    }
                                                                    if (chart3.hasOwnProperty('childItem') && chart3.childItem.length) {
                                                                        chart3.childItem.map(function(chart4) {
                                                                            if (chart4.hasOwnProperty('expended')) {
                                                                                chart4.expended = !!chart4.expended ? false : chart4.expended;
                                                                            }
                                                                        })
                                                                    }
                                                                })
                                                            }
                                                        })
                                                    }
                                                })
                                            }
                                        })
                                    }
                                    if (sub.hasOwnProperty('charts') && !!sub.charts && sub.charts.length) {
                                        sub.charts.map(function(chart1){
                                            if (chart1.hasOwnProperty('expended')){
                                                chart1.expended = !!chart1.expended ? false : chart1.expended;
                                            }
                                            if (chart1.hasOwnProperty('childItem') && chart1.childItem.length) {
                                                chart1.childItem.map(function(chart2){
                                                    if (chart2.hasOwnProperty('expended')){
                                                        chart2.expended = !!chart2.expended ? false : chart2.expended;
                                                    }
                                                    if (chart2.hasOwnProperty('childItem') && chart2.childItem.length) {
                                                        chart2.childItem.map(function(chart3){
                                                            if (chart3.hasOwnProperty('expended')){
                                                                chart3.expended = !!chart3.expended ? false : chart3.expended;
                                                            }
                                                            if (chart3.hasOwnProperty('childItem') && chart3.childItem.length) {
                                                                chart3.childItem.map(function(chart4) {
                                                                    if (chart4.hasOwnProperty('expended')) {
                                                                        chart4.expended = !!chart4.expended ? false : chart4.expended;
                                                                    }
                                                                })
                                                            }
                                                        })
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                            }
                        }
                    })
                }
                if (data.hasOwnProperty('types') && data.types.length) {
                    data.types.map(function(item){
                        if (item.hasOwnProperty('expended')){
                            item.expended = !!item.expended ? false : item.expended
                        }
                        if (item.hasOwnProperty('charts') && !!item.charts && item.charts.length) {
                            item.charts.map(function(chart1){
                                if (chart1.hasOwnProperty('expended')){
                                    chart1.expended = !!chart1.expended ? false : chart1.expended;
                                }
                                if (chart1.hasOwnProperty('childItem') && chart1.childItem.length) {
                                    chart1.childItem.map(function(chart2){
                                        if (chart2.hasOwnProperty('expended')){
                                            chart2.expended = !!chart2.expended ? false : chart2.expended;
                                        }
                                        if (chart2.hasOwnProperty('childItem') && chart2.childItem.length) {
                                            chart2.childItem.map(function(chart3){
                                                if (chart3.hasOwnProperty('expended')){
                                                    chart3.expended = !!chart3.expended ? false : chart3.expended;
                                                }
                                                if (chart3.hasOwnProperty('childItem') && chart3.childItem.length) {
                                                    chart3.childItem.map(function(chart4) {
                                                        if (chart4.hasOwnProperty('expended')) {
                                                            chart4.expended = !!chart4.expended ? false : chart4.expended;
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    })
                }

                if (data.hasOwnProperty('charts') && !!data.charts && data.charts.length) {
                    data.charts.map(function(chart1){
                        if (chart1.hasOwnProperty('expended')){
                            chart1.expended = !!chart1.expended ? false : chart1.expended;
                        }
                        if (chart1.hasOwnProperty('childItem') && chart1.childItem.length) {
                            chart1.childItem.map(function(chart2){
                                if (chart2.hasOwnProperty('expended')){
                                    chart2.expended = !!chart2.expended ? false : chart2.expended;
                                }
                                if (chart2.hasOwnProperty('childItem') && chart2.childItem.length) {
                                    chart2.childItem.map(function(chart3){
                                        if (chart3.hasOwnProperty('expended')){
                                            chart3.expended = !!chart3.expended ? false : chart3.expended;
                                        }
                                        if (chart3.hasOwnProperty('childItem') && chart3.childItem.length) {
                                            chart3.childItem.map(function(chart4) {
                                                if (chart4.hasOwnProperty('expended')) {
                                                    chart4.expended = !!chart4.expended ? false : chart4.expended;
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    })
                }

                if (data.hasOwnProperty('childItem') && data.childItem.length) {
                    data.childItem.map(function(chart2){
                        if (chart2.hasOwnProperty('expended')){
                            chart2.expended = !!chart2.expended ? false : chart2.expended;
                        }
                        if (chart2.hasOwnProperty('childItem') && chart2.childItem.length) {
                            chart2.childItem.map(function(chart3){
                                if (chart3.hasOwnProperty('expended')){
                                    chart3.expended = !!chart3.expended ? false : chart3.expended;
                                }
                                if (chart3.hasOwnProperty('childItem') && chart3.childItem.length) {
                                    chart3.childItem.map(function(chart4) {
                                        if (chart4.hasOwnProperty('expended')) {
                                            chart4.expended = !!chart4.expended ? false : chart4.expended;
                                        }
                                    })
                                }
                            })
                        }
                    })
                }

            } else {
                data['expended'] = true;
            }
        }

        $scope.expandAll = function (expanded) {
            if($scope.selectedTabs === generalLedger){
                $scope.accountsList.forEach(function(item) {
                    item.isExpand = expanded;
                });
            }
            if ($scope.selectedTabs === balanceSheet) {
                $scope.balanceSheets.map(function(item){
                    item.expended = expanded;
                    item.childs.map(function(child) {
                        child.expended = expanded;
                        child.types.map(function(type) {
                            type.expended = expanded
                            if (type.hasOwnProperty('types') && type.types.length) {
                                type.types.map(function(type) {
                                    type.expended = expanded
                                })
                            }
                            if (type.chart && type.chart.length ) {
                                type.chart.map(function(chart) {
                                    chart.expended = expanded
                                })
                            }
                        })
                    })
                })
            }
            if ($scope.selectedTabs === incomeStatus) {
                $scope.incomeSheets.map(function(item){
                    item.expended = expanded;
                })
            }
        }

        $scope.toggleRowIncome = function(data) {
            if(data.hasOwnProperty('expended')){
                data['expended'] = !data['expended'];
            } else {
                data['expended'] = true;
            }
        }

        $scope.checkExportOption = function () {
            var isVisible = false;
            if($scope.selectedTabs === generalLedger
                && $scope.accountsList.length
                && $scope.isFetchedReport) {
                    isVisible = true;
            } else if($scope.selectedTabs === balanceSheet
                && $scope.balanceSheets.length
                && $scope.isFetchedReport) {
                    isVisible = true;
            } else if($scope.selectedTabs === incomeStatus
                && $scope.incomeSheets.length
                && $scope.isFetchedReport) {
                isVisible = true;
            }

            return isVisible;
        }

        /**
         * @description creating dynamic column
         * @param {object} startDate 
         * @param {Number} columnCount 
         * @param {Array} compareToDate 
         * @param {String} changeShowAs 
         */
        function dynamicColumn (startDate, endDate, columnCount, compareToDate, changeShowAs) {
            // making dynamic column
            switch($scope.selFilter.columnData) {
                case 'Totals Only':
                    $scope.columnDates = $scope.getTotalPercentage(moment(startDate), moment(endDate), false, compareToDate, changeShowAs, $scope.selFilter.compareTo);
                    break;
                case 'Totals and % of total':
                    $scope.columnDates = $scope.getTotalPercentage(moment(startDate), moment(endDate), true, compareToDate, changeShowAs, $scope.selFilter.compareTo);
                    break;
                case 'Weeks (Totals Only)':
                    $scope.columnDates = $scope.getWeekRange(moment(startDate), moment(endDate), 1, 1, [], columnCount, compareToDate, changeShowAs, false, $scope.selFilter.compareTo);
                    break;
                case 'Weeks (Totals & %)':
                    $scope.columnDates = $scope.getWeekRange(moment(startDate), moment(endDate), 1 , 1, [], columnCount, compareToDate, changeShowAs, true, $scope.selFilter.compareTo);
                    break;
                case 'Months (Totals Only)':
                    $scope.columnDates = $scope.getMonthRange(moment(startDate), moment(endDate), 1 , 1, [], true, columnCount, compareToDate, changeShowAs, false, $scope.selFilter.compareTo);
                    break;
                case 'Months (Totals & %)':
                    $scope.columnDates  = $scope.getMonthRange(moment(startDate),moment(endDate), 1 , 1, [], true, columnCount, compareToDate, changeShowAs, true, $scope.selFilter.compareTo);
                    break;
                case 'Quarters (Total Only)':
                    $scope.columnDates = $scope.getQuarterRange(moment(startDate), moment(endDate), 1 , 1, [], true, columnCount, compareToDate, changeShowAs, false, $scope.selFilter.compareTo);
                    break;
                case 'Quarters (Totals & %)':
                    $scope.columnDates  = $scope.getQuarterRange(moment(startDate), moment(endDate), 1 , 1, [], true, columnCount, compareToDate, changeShowAs, true, $scope.selFilter.compareTo);
                    break;
            };
        }

        /**
         * @description compareToDateRange used for perivious date range for report.
         * @param {object} startDate 
         * @param {object} endDate 
         * @returns array compareToDate
         */
        function compareToDateRange (startDate, endDate) {
            var sDate, eDate, diffDays;
            var compareToDate = [];
            switch($scope.selFilter.compareTo) {
                case 'Previous Year':
                    sDate = moment(startDate).subtract(1, 'years').startOf('year');
                    eDate = moment(sDate).endOf('year');
                    compareToDate = [sDate.toDate(), eDate.toDate()];
                    break;
                case 'Previous Period':
                    diffDays = moment(startDate).diff(moment(endDate), 'days') + 1;
                    sDate = moment(startDate).subtract(Math.abs(diffDays), 'days').startOf('day');
                    eDate = moment(sDate).add((Math.abs(diffDays) - 1), 'days').endOf('day');
                    compareToDate = [sDate.toDate(), eDate.toDate()];
                    break;
                case 'Year-to-Date':
                    sDate = moment().startOf('year').toDate();
                    eDate = moment().endOf('day').toDate();
                    compareToDate = [sDate, eDate];
                    break;
            }
            return compareToDate;
        }

        /**
         * @description balance sheet calculation
         */
        $scope.setBalanceSheetReport = function() {
            $scope.detailTypes = angular.copy(accountingConstant.balanceTypes);
            $scope.balanceSheets = angular.copy(accountingConstant.balanceSheets);
            if ($scope.accountMethod  === 'Cash') {
                $scope.balanceSheets[0].childs[0].types.splice(0,1);
                $scope.balanceSheets[1].childs[0].types[0].types.splice(0,1);
            }
            
            $scope.isFetchedReport = true;
            let startDate = angular.copy($scope.startDate);
            let endDate = angular.copy($scope.endDate);
            let compareToDate = compareToDateRange(startDate, $scope.endDate);
            let changeShowAs = $scope.selFilter.changeAs != 'None' ? $scope.selFilter.changeAs : null;
            var columnCount = 1;
            dynamicColumn(startDate, endDate, columnCount, compareToDate, changeShowAs);
            let searchProperties = {
                clientAccountId: $scope.main_accountId,
                detailsTypes: $scope.detailTypes,
                reportType: balanceSheet,
                selectedRanges: [$scope.startDate, $scope.endDate],
                compareToRanges: compareToDate,
                accountMethod: $scope.accountMethod
            };
            TransactionService.query(searchProperties, function (transaction) {
                const cTransactins = angular.copy(transaction[0].present) || [];
                const pTransactins = angular.copy(transaction[0].pasts) || [];
                var columnDataWithZero = [];
                var retainEarningColumnsData = [];
                var netIncome = angular.copy($scope.netIncome),
                    IncomeColumnsData = netIncome.columnsData,
                    netRetainEarning = angular.copy($scope.netRetainEarning),
                    netRetainEarningColumnsData = netRetainEarning.columnsData;
                netIncome.ctotalBalance = netIncome.balance;
                netIncome.ptotalBalance = netIncome.pBalance;
                netRetainEarning.ctotalBalance = netRetainEarning.balance;
                netRetainEarning.ptotalBalance = netRetainEarning.pBalance;
                $scope.balanceSheets[1].childs[1].income = true;
                $scope.balanceSheets.map(item => {
                    item['columnsData'] = [];
                    _.each(item.childs, function(child, index1) {
                        item.childs[index1]['columnsData'] = [];
                        var childColumnData = item.childs[index1]['columnsData'];
                        child.totalAmount = 0;
                        child.pTotalAmount = 0;
                        if (child.hasOwnProperty('types') && child.types.length && child.types[0].name == 'Equity') {
                            item.childs[index1]['charts'] = angular.copy(balanceSheetChartList[child.name]);
                            if (item.childs[index1]['charts'] && item.childs[index1]['charts'].length) {
                                child.types = [];
                            }
                        }
                        if (child.types.length) {
                            _.each(child.types, function(type, index2) {
                                type.totalAmount = 0;
                                type.pTotalAmount = 0;
                                item.childs[index1]['types'][index2]['columnsData'] = [];
                                var typesColumnsData = item.childs[index1]['types'][index2]['columnsData'];
                                if (type.hasOwnProperty('types') && type.types.length && type.name == 'Long Term Liabilities') {
                                    item.childs[index1]['types'][index2]['charts'] = angular.copy(balanceSheetChartList[type.name]);
                                    if (item.childs[index1]['types'][index2]['charts'] && item.childs[index1]['types'][index2]['charts'].length) {
                                        type.types = [];
                                    }
                                }
                                var tempCharts = angular.copy(balanceSheetChartList[type.name]);
                                if (type.hasOwnProperty('types') && type.types.length) {
                                    _.each(type.types, function(typeChild, index3) {
                                        typeChild.totalAmount = 0;
                                        typeChild.pTotalAmount = 0;
                                        typeChild['columnsData'] = [];
                                        var typeChildColumnsData = item.childs[index1]['types'][index2]['types'][index3]['columnsData'];
                                        item.childs[index1]['types'][index2]['types'][index3]['charts'] = angular.copy(balanceSheetChartList[type.name]);
                                        let typeChildCharts = angular.copy(balanceSheetChartList[typeChild.name]);
                                        typeChildCharts = typeChildCharts || [];
                                        if (typeChildCharts && typeChildCharts.length) {
                                            item.childs[index1]['types'][index2]['types'][index3]['charts'] = angular.copy(typeChildCharts);
                                            chartBalance(item.childs[index1]['types'][index2]['types'][index3]['charts'], cTransactins, pTransactins, changeShowAs, typeChildColumnsData, false)
                                            item.childs[index1]['types'][index2]['types'][index3]['charts'].map(function(chart) {
                                                item.balance += chart.ctotalBalance;
                                                child.totalAmount += chart.ctotalBalance;
                                                type.totalAmount += chart.ctotalBalance;
                                                typeChild.totalAmount += chart.ctotalBalance;
                                                item.pBalance += chart.ptotalBalance;
                                                child.pTotalAmount += chart.ptotalBalance;
                                                type.pTotalAmount += chart.ptotalBalance;
                                                typeChild.pTotalAmount += chart.ptotalBalance;
                                            })
                                        } else {
                                            typeChildColumnsData.push(angular.copy($scope.columnDates))
                                        }
                                        var typeChildColumnsDataCopy = angular.copy(typeChildColumnsData);
                                        typeChild['columnsData'] = reduceData(typeChildColumnsDataCopy);
                                        var typeChildColumnData = angular.copy(typeChild['columnsData']);
                                        typesColumnsData.push(typeChildColumnData);
                                    })
    
                                } else {
                                    item.childs[index1]['types'][index2]['charts'] = angular.copy(balanceSheetChartList[type.name]);
                                    if (tempCharts && tempCharts.length) {
                                        tempCharts = tempCharts || [];
                                        item.childs[index1]['types'][index2]['charts'] = angular.copy(tempCharts);
                                        chartBalance(item.childs[index1]['types'][index2]['charts'], cTransactins, pTransactins, changeShowAs, typesColumnsData, false)
                                        item.childs[index1]['types'][index2]['charts'].map(function(chart) {
                                            item.balance += chart.ctotalBalance;
                                            child.totalAmount += chart.ctotalBalance;
                                            type.totalAmount += chart.ctotalBalance;
                                            item.pBalance += chart.ptotalBalance;
                                            child.pTotalAmount += chart.ptotalBalance;
                                            type.pTotalAmount += chart.ptotalBalance;
                                        })
                                    } else {
                                        if(!type.hasOwnProperty('types')) {
                                            typesColumnsData.push(angular.copy($scope.columnDates))
                                        }
                                    }
                                }
                                var typesColumnsDataCopy = angular.copy(typesColumnsData);
                                item.childs[index1]['types'][index2]['columnsData'] = reduceData(typesColumnsDataCopy);
                                var childIndexColumnData = angular.copy(item.childs[index1]['types'][index2]['columnsData']);
                                childColumnData.push(childIndexColumnData);
                            });
                        }
                        if (item.childs[index1]['charts'] && item.childs[index1]['charts'].length) {
                            chartBalance(item.childs[index1]['charts'], cTransactins, pTransactins, changeShowAs, childColumnData, false);
                            if (item.childs[index1].income) {
                                item.childs[index1]['charts'].push(netIncome);
                            }
                            var retainEarning = item.childs[index1]['charts'].filter(function(item){
                                return item.name === 'Retained Earnings';
                            })[0];

                            $scope.globalRetainedEarnings = item.childs[index1]['charts'].filter(function(item){
                                return item.accountType === 'Equity';
                            });

                            $scope.globalCTotal = 0;
                            $scope.globalPTotal = 0;
                            $scope.globalRetainedEarnings.forEach(function(gre) {
                                gre.ctotalBalance = gre.ctotalBalance + netRetainEarning.ctotalBalance;
                                gre.ptotalBalance = gre.ptotalBalance + netRetainEarning.ptotalBalance;
                                $scope.globalCTotal += gre.ctotalBalance;
                                $scope.globalPTotal += gre.ptotalBalance;
                            })
                            retainEarning.ctotalBalance = retainEarning.ctotalBalance + netRetainEarning.ctotalBalance;
                            retainEarning.ptotalBalance = retainEarning.ptotalBalance + netRetainEarning.ptotalBalance;
                            var retainEarningColumnsData = angular.copy(retainEarning.columnsData),
                                retainEarningColumnsData2 = angular.copy(netRetainEarningColumnsData);
                            retainEarningColumnsData = reduceData([retainEarningColumnsData,  retainEarningColumnsData2]);
                           
                            item.childs[index1]['charts'].map(function(chart) {
                                if (chart.name  === 'Retained Earnings') {
                                    chart.columnsData = retainEarningColumnsData;
                                    chart.ctotalBalance = retainEarning.ctotalBalance;
                                    chart.ptotalBalance = retainEarning.ptotalBalance;
                                }
                                item.balance += chart.ctotalBalance;
                                child.totalAmount += chart.ctotalBalance;
                                item.pBalance += chart.ptotalBalance;
                                child.pTotalAmount += chart.ptotalBalance;
                            })
                            childColumnData.push(netRetainEarningColumnsData);
                            childColumnData.push(IncomeColumnsData);
                        }
                        var childColumnDataCopy = angular.copy(childColumnData);
                        item.childs[index1]['columnsData'] = reduceData(childColumnDataCopy);
                        var itemIndexColumnData = angular.copy(item.childs[index1]['columnsData']);
                        item.columnsData.push(itemIndexColumnData);
                    });

                    var itemColumnsData = angular.copy(item.columnsData);
                    item.columnsData = reduceData(itemColumnsData);
                    var columnDataZero = item.columnsData.filter(function(item){
                        return item.type == 'current' && item.totals == 0
                    })
                    if (columnDataZero) {
                        var rootindex = columnDataZero.map(function(item){
                            return item.root;
                        })
                        columnDataWithZero = columnDataWithZero.concat(rootindex);
                    }
                    return item;
                });
                          
                removeIndex = _.filter(columnDataWithZero, (val, i, iteratee) => _.includes(iteratee, val, i + 1));

                $scope.balanceSheets.map(item => {
                    var itemColumnsData = angular.copy(item.columnsData);
                    _.each(item.childs, function(child) {
                        var childColumnsData = angular.copy(child.columnsData);
                        _.each(child.types, function(type) {
                            var typeColumnsData = angular.copy(type.columnsData);

                            if (type.hasOwnProperty('types') && type.types.length) {

                                _.each(type.types, function(childType) {
                                    var typeChildColumnsData = angular.copy(childType.columnsData);
                                    if (childType['charts'] && childType['charts'].length) {
                                        childType['charts'].map(chart => {
                                            var chartColumnsData = angular.copy(chart.columnsData);
                                            if (chart.childItem && chart.childItem.length) {
                                                chart.childItem.map(child1 =>{
                                                    if (child1.childItem.length) {
                                                        child1.childItem.map(child2 =>{
                                                            if (child2.childItem.length) {
                                                                child2.childItem.map(child3 =>{
                                                                    if (child3.childItem.length) {
                                                                        child3.childItem.map(child4 => {
                                                                            if (child4.childItem.length) {
                                                                                if ($scope.rowSelection === 'nonZero') {
                                                                                    child4.childItem = child4.childItem.filter(function(chart){
                                                                                        return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                                                    });
                                                                                }
                                                                            }
                                                                        })
                                                                        if ($scope.rowSelection === 'nonZero') {
                                                                            child3.childItem = child3.childItem.filter(function(chart){
                                                                                return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                                            });
                                                                        }
                                                                    }
                                                            
                                                                })
                                                                if ($scope.rowSelection === 'nonZero') {
                                                                    child2.childItem = child2.childItem.filter(function(chart){
                                                                        return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                                    });
                                                                }
                                                            }
                                                        })
                                                        if ($scope.rowSelection === 'nonZero') {
                                                            child1.childItem = child1.childItem.filter(function(chart){
                                                                return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                            });
                                                        }
                                                    }
                                                })
                                                if ($scope.rowSelection === 'nonZero') {
                                                    chart.childItem = chart.childItem.filter(function(chart){
                                                        return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                    });
                                                }
                                            }
                                            chart.columnsData = childPercentage(typeChildColumnsData, chartColumnsData);
                                            if ($scope.columnSelection === 'nonZero'){
                                                var chartColumnsDataCopy = angular.copy(chart.columnsData);
                                                chart.columnsData = removeZeroTotal(chartColumnsDataCopy);
                                            }
                                            return chart;
                                        });
                                    }

                                    if ($scope.rowSelection === 'nonZero') {
                                        if (childType['charts'] && childType['charts'].length) {
                                            childType['charts'] = childType['charts'].filter(function(chart){
                                                return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                            });
                                        }
                                    }
                                    childType.columnsData = childPercentage(typeColumnsData, typeChildColumnsData);
                                    if ($scope.columnSelection === 'nonZero') {
                                        var typeColumnsDataCopy = angular.copy(childType.columnsData);
                                        childType.columnsData = removeZeroTotal(typeColumnsDataCopy);
                                    }
                                })
                                if ($scope.rowSelection === 'nonZero') {
                                    type.types = type.types.filter(function(item) {
                                        return item.pTotalAmount !== 0 || item.totalAmount !== 0;
                                    })
                                }
                                
                            } else {
                                if(type['charts'] && type['charts'].length) {
                                    type['charts'].map(chart => {
                                        var chartColumnsData = angular.copy(chart.columnsData);
                                        if (chart.childItem && chart.childItem.length) {
                                            chart.childItem.map(child1 =>{
                                                if (child1.childItem.length) {
                                                    child1.childItem.map(child2 =>{
                                                        if (child2.childItem.length) {
                                                            child2.childItem.map(child3 =>{
                                                                if (child3.childItem.length) {
                                                                    child3.childItem.map(child4 => {
                                                                        if (child4.childItem.length) {
                                                                            if ($scope.rowSelection === 'nonZero') {
                                                                                child4.childItem = child4.childItem.filter(function(chart){
                                                                                    return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                                                });
                                                                            }
                                                                        }
                                                                    })
                                                                    if ($scope.rowSelection === 'nonZero') {
                                                                        child3.childItem = child3.childItem.filter(function(chart){
                                                                            return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                                        });
                                                                    }
                                                                }
                                                        
                                                            })
                                                            if ($scope.rowSelection === 'nonZero') {
                                                                child2.childItem = child2.childItem.filter(function(chart){
                                                                    return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                                });
                                                            }
                                                        }
                                                    })
                                                    if ($scope.rowSelection === 'nonZero') {
                                                        child1.childItem = child1.childItem.filter(function(chart){
                                                            return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                        });
                                                    }
                                                }
                                            })
                                            if ($scope.rowSelection === 'nonZero') {
                                                chart.childItem = chart.childItem.filter(function(chart){
                                                    return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                });
                                            }
                                        }
                                        chart.columnsData = childPercentage(typeColumnsData, chartColumnsData);
                                        if ($scope.columnSelection === 'nonZero'){
                                            var chartColumnsDataCopy = angular.copy(chart.columnsData);
                                            chart.columnsData = removeZeroTotal(chartColumnsDataCopy);
                                        }
                                        return chart;
                                    });
                                }
                            }
                            if ($scope.rowSelection === 'nonZero') {
                                if(type['charts'] && type['charts'].length) {
                                    type['charts'] = type['charts'].filter(function(chart) {
                                        return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                    });
                                }
                            }
                            type.columnsData = childPercentage(childColumnsData, typeColumnsData);
                            if ($scope.columnSelection === 'nonZero'){
                                var typeColumnsDataCopy = angular.copy(type.columnsData);
                                type.columnsData = removeZeroTotal(typeColumnsDataCopy);
                            }
                        });
                        
                        if ($scope.rowSelection === 'nonZero') {
                            child.types = child.types.filter(function(item){
                                return item.pTotalAmount !== 0 || item.totalAmount !== 0;
                            })
                        }
                        if (child.charts && child.charts.length) {
                            child['charts'].map(chart => {
                                var chartColumnsData = angular.copy(chart.columnsData);
                                if (chart.childItem && chart.childItem.length) {
                                    chart.childItem.map(child1 =>{
                                        if (child1.childItem.length) {
                                            child1.childItem.map(child2 =>{
                                                if (child2.childItem.length) {
                                                    child2.childItem.map(child3 =>{
                                                        if (child3.childItem.length) {
                                                            child3.childItem.map(child4 => {
                                                                if (child4.childItem.length) {
                                                                    if ($scope.rowSelection === 'nonZero') {
                                                                        child4.childItem = child4.childItem.filter(function(chart){
                                                                            return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                                        });
                                                                    }
                                                                }
                                                            })
                                                            if ($scope.rowSelection === 'nonZero') {
                                                                child3.childItem = child3.childItem.filter(function(chart){
                                                                    return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                                });
                                                            }
                                                        }
                                                
                                                    })
                                                    if ($scope.rowSelection === 'nonZero') {
                                                        child2.childItem = child2.childItem.filter(function(chart){
                                                            return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                        });
                                                    }
                                                }
                                            })
                                            if ($scope.rowSelection === 'nonZero') {
                                                child1.childItem = child1.childItem.filter(function(chart){
                                                    return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                });
                                            }
                                        }
                                    })
                                    if ($scope.rowSelection === 'nonZero') {
                                        chart.childItem = chart.childItem.filter(function(chart){
                                            return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                        });
                                    }
                                }
                                chart.columnsData = childPercentage(childColumnsData, chartColumnsData);
                                if ($scope.columnSelection === 'nonZero'){
                                    var chartColumnsDataCopy = angular.copy(chart.columnsData);
                                    chart.columnsData = removeZeroTotal(chartColumnsDataCopy);
                                }
                                return chart;
                            });
                            
                            if ($scope.rowSelection === 'nonZero') {
                                if (child['charts'] && child['charts'].length) {
                                    child['charts'] = child['charts'].filter(function(chart){
                                        return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                    });
                                }
                            }
                        }

                        child.columnsData = childPercentage(itemColumnsData, childColumnsData);

                        if ($scope.columnSelection === 'nonZero'){
                            var childColumnsDataCopy = angular.copy(child.columnsData);
                            child.columnsData = removeZeroTotal(childColumnsDataCopy);
                        }

                    });

                    item.columnsData = childPercentage(itemColumnsData, itemColumnsData);

                    if ($scope.columnSelection === 'nonZero'){
                        var itemColumnsDataCopy = angular.copy(item.columnsData);
                        item.columnsData = removeZeroTotal(itemColumnsDataCopy);
                    }

                    if ($scope.rowSelection === 'nonZero') {
                        item.childs = item.childs.filter(function(item){
                            return item.totalAmount !== 0 || item.pTotalAmount !== 0;
                        });
                    }

                    return item;
                });
                $scope.showSpinner = false;
            });
        }

        /**
         * @description get the list of accounts  wrt to childItems.
         * @param {object} accounts
         * @return listData object with childItems
         */
        function getAccountList(accounts) {
            var listData = accounts.filter(item => item.isSubAccount == 0).map(e => {
                e.childItem = [];
                return e;
            });
            listData = makeChildElements(listData, accounts);
            return listData;
        }

        function makeChildElements(listData, accounts) {
            for(var i=0; i < listData.length; i++ ) {
                listData[i]['childItem'] = [];
                for (var j=0; j < accounts.length; j++) {
                    if (accounts[j].isSubAccount == 1) {
                        var index = listData.findIndex(item => item._id == accounts[j].mainAccount._id);
                        if (index >= 0) {
                            if (listData[index].hasOwnProperty('childItem')) {
                                var index2 = listData[index]['childItem'].filter(item => item._id == accounts[j]._id);
                                if(!index2.length) {
                                    listData[index]['childItem'].push(accounts[j]);
                                }
                            }
                        }
                    }
                }
                if(listData[i].childItem.length) {
                    makeChildElements(listData[i].childItem, accounts);
                }
            }
            return listData;
        }
        
        /**
         * @description Calculation of chart balance
         * @param {*} chartArray 
         * @param {*} cTransactins 
         * @param {*} pTransactins 
         * @param {*} changeShowAs 
         * @param {*} typesColumnsData 
         */
        function chartBalance (chartArray, cTransactins, pTransactins, changeShowAs, typesColumnsData, income, retainEarning) {
            console.log(chartArray);
            chartArray.map(function(singleCharts, index) {
                var singleChartcolumnData = [],
                    updateCharts = updateTranactionDataInChart(singleCharts, cTransactins);
                    singleCharts = generateNextColumn(updateCharts, $scope.selFilter.compareTo, changeShowAs, income, retainEarning);
                    var singleChartcolumnDataCopy = angular.copy(singleCharts['columnsData']);
                if (singleCharts.childItem && singleCharts.childItem.length) {
                    singleChartcolumnData.push(singleChartcolumnDataCopy);
                    singleCharts.childItem.map(function(child1, index1) {
                        var child1ChartcolumnData = [],
                            updateChild1 = updateTranactionDataInChart(child1, cTransactins);
                            child1 = generateNextColumn(updateChild1, $scope.selFilter.compareTo, changeShowAs, income, retainEarning);
                            var child1ChartcolumnDataCopy = angular.copy(child1['columnsData']);
                        if (child1.childItem.length) {
                            child1ChartcolumnData.push(child1ChartcolumnDataCopy);
                            child1.childItem.map(function(child2, index2) {
                                var child2ChartcolumnData = [],
                                    updateChild2 = updateTranactionDataInChart(child2, cTransactins);
                                    child2 = generateNextColumn(updateChild2, $scope.selFilter.compareTo, changeShowAs, income, retainEarning);
                                    var child2ChartcolumnDataCopy = angular.copy(child2['columnsData']);
                                if (child2.childItem.length) {
                                    child2ChartcolumnData.push(child2ChartcolumnDataCopy);
                                    child2.childItem.map(function(child3, index3) {
                                        var child3ChartcolumnData = [],
                                            updateChild3 = updateTranactionDataInChart(child3, cTransactins);
                                            child3 = generateNextColumn(updateChild3, $scope.selFilter.compareTo, changeShowAs, income, retainEarning);
                                            var child3ChartcolumnDataCopy = angular.copy(child3.columnsData);
                                        if(child3.childItem.length) {
                                            child3ChartcolumnData.push(child3ChartcolumnDataCopy);
                                            child3.childItem.map(function(child4, index4) {
                                                var updateChild4 = updateTranactionDataInChart(child4, cTransactins);
                                                    child4 = generateNextColumn(updateChild4, $scope.selFilter.compareTo, changeShowAs, income, retainEarning);
                                                    chartArray[index]['childItem'][index1]['childItem'][index2]['childItem'][index3]['childItem'][index4]['columnsData'] =  angular.copy(child4['columnsData']);
                                                    var childItem4IndexColumnData = angular.copy(chartArray[index]['childItem'][index1]['childItem'][index2]['childItem'][index3]['childItem'][index4]['columnsData']);
                                                child3ChartcolumnData.push(childItem4IndexColumnData);
                                                child3['ctotalBalance'] += child4['ctotalBalance'];
                                                child3['ptotalBalance'] += child4['ptotalBalance'];
                                            })
                                            var child3ChartcolumnDataReduce = reduceData(child3ChartcolumnData);
                                            child3ChartcolumnDataCopy = angular.copy(child3ChartcolumnDataReduce);
                                            
                                        }
                                        chartArray[index]['childItem'][index1]['childItem'][index2]['childItem'][index3]['columnsData'] =  angular.copy(child3ChartcolumnDataCopy);
                                        var childItem3IndexColumnData = angular.copy(chartArray[index]['childItem'][index1]['childItem'][index2]['childItem'][index3]['columnsData']);
                                        child2ChartcolumnData.push(childItem3IndexColumnData);
                                        child2['ctotalBalance'] += child3['ctotalBalance'];
                                        child2['ptotalBalance'] += child3['ptotalBalance'];
                                    })
                                    var child2ChartcolumnDataReduce = reduceData(child2ChartcolumnData);
                                    child2ChartcolumnDataCopy = angular.copy(child2ChartcolumnDataReduce);
                                }
                                chartArray[index]['childItem'][index1]['childItem'][index2]['columnsData'] =  angular.copy(child2ChartcolumnDataCopy);
                                var childItem2IndexColumnData = angular.copy(chartArray[index]['childItem'][index1]['childItem'][index2]['columnsData']);
                                child1ChartcolumnData.push(childItem2IndexColumnData);
                                child1['ctotalBalance'] += child2['ctotalBalance'];
                                child1['ptotalBalance'] += child2['ptotalBalance'];
                            })
                            var child1ChartcolumnDataReduce = reduceData(child1ChartcolumnData);
                            child1ChartcolumnDataCopy = angular.copy(child1ChartcolumnDataReduce);
                        }
                        chartArray[index]['childItem'][index1]['columnsData'] = angular.copy(child1ChartcolumnDataCopy);
                        var childItem1IndexColumnData = angular.copy(chartArray[index]['childItem'][index1]['columnsData']);
                        singleChartcolumnData.push(childItem1IndexColumnData);
                        singleCharts['ctotalBalance'] += child1['ctotalBalance'];
                        singleCharts['ptotalBalance'] += child1['ptotalBalance'];
                    })
                    var singleChartcolumnDataReduce = reduceData(singleChartcolumnData);
                    singleChartcolumnDataCopy = angular.copy(singleChartcolumnDataReduce);
                }
                chartArray[index]['columnsData'] = angular.copy(singleChartcolumnDataCopy);
                var singleIndexChartsColumnData = angular.copy(chartArray[index]['columnsData']);
                typesColumnsData.push(singleIndexChartsColumnData);
            });
        }

        function updateTranactionDataInChart(singleCharts, cTransactins) {
            // For current data
            // debit account
            if(singleCharts.detailType == 'Material-COGS')
                console.log(singleCharts);
            singleCharts.cTransaction = [];
            var debitAccountIncrease = (accountType[0].name === singleCharts.parentOfAccountType)
                    || (accountType[0].name === singleCharts.parentOfParentAccountType)
                    || (accountType[4].name === singleCharts.parentOfAccountType)
                    || (accountType[4].name === singleCharts.parentOfParentAccountType);
            for (var i=cTransactins.length-1; i>=0; i--) {
                if (cTransactins[i].expense && Array.isArray(cTransactins[i].expense)
                    && cTransactins[i].expense.length) {
                    for (var j = 0; j < cTransactins[i].expense.length; j++) {
                        if (cTransactins[i].expense[j].expenseAccount == singleCharts._id) {
                            var copyObj = angular.copy(cTransactins[i].expense[j]);
                            copyObj.date = cTransactins[i].date;
                            copyObj.type = 'debit';
                            copyObj.debitIncrease = debitAccountIncrease;
                            singleCharts['cTransaction'].push(copyObj);
                        }
                    }
                }
                // credit account
                if (cTransactins[i].paymentAccounts && Array.isArray(cTransactins[i].paymentAccounts)
                    && cTransactins[i].paymentAccounts.length) {
                    for (var j = 0; j < cTransactins[i].paymentAccounts.length; j++) {
                        if (cTransactins[i].paymentAccounts[j].paymentAccount == singleCharts._id) {
                            var copyObj = angular.copy(cTransactins[i].paymentAccounts[j]);
                            copyObj.date = cTransactins[i].date;
                            copyObj.type = 'credit';
                            copyObj.debitIncrease = debitAccountIncrease
                            singleCharts['cTransaction'].push(copyObj);
                        }
                    }
                }
            }
            return singleCharts;
        }
        /**
         * @description Calculation of column data from child column to parent column
         * @param {Array} cd colunm data array of object
         * @param {Binary} income  Is reduce data done calculation for income or not
         */
        function reduceData(cd, income) {
            var columnData = cd.reduce(function(p,c) {
                p.map(function(item){
                    c.map(function(item1) {
                        if(item.title == item1.title && item.root == item1.root) {
                            item1.totals = income ? (item.totals - item1.totals) : (item1.totals + item.totals)
                        }
                    })
                })
              return c;
            },[]);
            return columnData;
        }
        /**
         * @description Column data with non zero
         * @param {object} columnData column data object
         */
        function removeZeroTotal (columnData){
            var filterData = columnData.filter(function(item){
                return !(removeIndex.includes(item.root));
            })
            $scope.columnDates = filterData;
            return filterData;
        }
        /**
         * @description childPercentage calculate the percentage of child from total of parent,
         *  also calculate the compare % change from current child to previous child.
         * @param {Object} parent Parent column data object
         * @param {Object} child Child column data object
         */
        function childPercentage (parent, child){
            var currentTotal = 0,
                    parentTotal = 0,
                    compareTotal = 0;
            var childPer = child.map(function(item) {
                if (item.type === 'current') {
                    currentTotal = item.totals;
                }
                if (item.type === 'percentage'){
                    var parentData = parent.filter(function(pItem) {
                        return pItem.root == item.root && pItem.type == 'current';
                    })
                    parentTotal = parentData.length ? parentData[0].totals : 0;
                    item.totals = parentTotal !== 0 ? (currentTotal/parentTotal)*100 : 0;
                }
                if (item.type == 'compare') {
                    compareTotal = item.totals;
                }
                if (item.type == 'amountChange') {
                    item.totals = compareTotal - currentTotal;
                }
                if (item.type == 'percChange') {
                    item.totals = ChangePercentage(currentTotal, compareTotal);
                    item.totals = isFinite(item.totals) ? item.totals : null
                }
                return item;
            })
            return childPer
        }

        $scope.setExtraIncomeSheetReport = function() {
            let startDate = angular.copy($scope.startDate);
            let endDate = angular.copy($scope.endDate);
            let compareToDate = compareToDateRange($scope.startDate, $scope.endDate);
            let changeShowAs = $scope.selFilter.changeAs != 'None' ? $scope.selFilter.changeAs : null;
            var columnCount = 1;
            dynamicColumn(startDate, endDate, columnCount, compareToDate, changeShowAs)

            let types = $scope.incomeTypes;
            //types.push('Accounts Payable');
            let searchProperties = {
                clientAccountId: $scope.main_accountId,
                detailsTypes: types,
                reportType: balanceSheet,
                selectedRanges: [$scope.startDate, $scope.endDate],
                compareToRanges: compareToDate,
                accountMethod: 'Accrual'
            };

            TransactionService.query(searchProperties, function (transaction) { 
                const cTransactins = angular.copy(transaction[0].present) || [];
                const pTransactins = angular.copy(transaction[0].pasts) || [];
                $scope.othersListOfExpenseAccounts = {};
                $scope.othersListOfPaymentAccounts = {};
                $scope.listOfTransactionTypes = {};

                _.each(cTransactins, function(item) {
                    //if(item.transactionType == 'JournalEntry') {
                        if(!$scope.listOfTransactionTypes[item.transactionType]) {
                            $scope.listOfTransactionTypes[item.transactionType] = {
                                totalExpenseAmount: 0,
                                totalPaymentAmount: 0
                            }
                        }

                        $scope.listOfTransactionTypes[item.transactionType].totalExpenseAmount += 
                            item.totalExpenseAmount;
                        $scope.listOfTransactionTypes[item.transactionType].totalPaymentAmount += 
                            item.totalPaymentAmount;

                        _.each(item.expense, function(exp) {
                            if(!$scope.othersListOfExpenseAccounts[exp.name])
                                $scope.othersListOfExpenseAccounts[exp.name] = 0;

                            $scope.othersListOfExpenseAccounts[exp.name] += exp.expenseAmount;
                        });

                        _.each(item.paymentAccounts, function(exp) {
                            if(!$scope.othersListOfPaymentAccounts[exp.name])
                                $scope.othersListOfPaymentAccounts[exp.name] = 0;

                            $scope.othersListOfPaymentAccounts[exp.name] += exp.paymentAmount;
                        });

                        $scope.accrualExpenseTotalValue += item.totalExpenseAmount;
                        $scope.accrualPaymentTotalValue += item.totalPaymentAmount;
                    //}
                });

                var columnDataWithZero = [];
                var grossProfit = { name : 'Gross Profit', columnsData: [], balance:0, pBalance:0 },
                    netOperatingIncome = {name : 'Net Operating Income', columnsData: [], balance:0, pBalance:0 },
                    netOtherIncome = {name : 'Net Other Income', columnsData: [], balance:0, pBalance:0 },
                    netIncome = {name : 'Net Income', columnsData: [], balance:0, pBalance:0},
                    grossProfitColumnsData = grossProfit.columnsData,
                    netOperatingIncomeColumnsData = netOperatingIncome.columnsData,
                    netOtherIncomeColumnsData = netOtherIncome.columnsData,
                    netIncomeColumnsData = netIncome.columnsData;
                var incomeSheets = angular.copy(accountingConstant.incomeSheets); 
                $scope.testIncomeSheets = incomeSheets; //$filter('filter')(incomeSheets, {name: 'Cost Of Goods Sold'});
                // var idx = $scope.testIncomeSheets[0].detailType.indexOf('Material-COGS');
                // if(idx != -1)
                //     $scope.testIncomeSheets[0].detailType = $scope.testIncomeSheets[0].detailType[idx];

                $scope.testIncomeSheets.map(function(item, index) {
                    item['columnsData'] = [];
                    var itemColumnsData = item['columnsData'];
                    var charts = angular.copy(balanceSheetChartList[item.name]);
                    if (charts && charts.length) {
                        charts = charts || [];
                        item['charts'] = angular.copy(charts);
                        chartBalance(item['charts'], cTransactins, pTransactins, changeShowAs, itemColumnsData, true, false);
                        item['charts'].map(function(chart) {
                            item.balance += chart.ctotalBalance;
                            item.pBalance += chart.ptotalBalance;
                        })
                    } else {
                        itemColumnsData.push(angular.copy($scope.columnDates));
                    }
                    var itemColumnsDataCopy = angular.copy(itemColumnsData);
                    item['columnsData'] = reduceData(itemColumnsDataCopy, false);
                    var columnDataZero = item.columnsData.filter(function(item) {
                        return item.type == 'current' && item.totals == 0
                    })
                    if (columnDataZero) {
                        var rootindex = columnDataZero.map(function(item){
                            return item.root;
                        })
                        columnDataWithZero = columnDataWithZero.concat(rootindex);
                    }
                    if(index > 0) {
                        removeIndex = _.filter(columnDataWithZero, (val, i, iteratee) => _.includes(iteratee, val, i + 1));
                        columnDataWithZero = angular.copy(removeIndex);
                    }
                    itemColumnsDataCopy = angular.copy(item['columnsData'])
                    if (index <= 1 ) {
                        if(index == 0) {
                            grossProfit.pBalance += item.pBalance;
                            grossProfit.balance += item.balance;
                        }
                        grossProfitColumnsData.push(itemColumnsDataCopy);
                    }
                    if (item.name === 'Cost Of Goods Sold') {
                        var grossProfitColumnsDataCopy = angular.copy(grossProfitColumnsData)
                        grossProfit.columnsData = reduceData(grossProfitColumnsDataCopy, true);
                        grossProfit.pBalance -= item.pBalance;
                        grossProfit.balance -= item.balance;
                        netOperatingIncome.pBalance += grossProfit.pBalance;
                        netOperatingIncome.balance += grossProfit.balance;
                        netOperatingIncomeColumnsData.push(grossProfit.columnsData);
                    }
                    if (index == 2 ) {
                        netOperatingIncomeColumnsData.push(itemColumnsDataCopy);
                        var netOperatingIncomeColumnsDataCopy = angular.copy(netOperatingIncomeColumnsData)
                        netOperatingIncome.columnsData = reduceData(netOperatingIncomeColumnsDataCopy, true);
                        netOperatingIncome.pBalance -= item.pBalance;
                        netOperatingIncome.balance -= item.balance;
                        netIncome.pBalance += netOperatingIncome.pBalance;
                        netIncome.balance += netOperatingIncome.balance;
                        netIncomeColumnsData.push(netOperatingIncome.columnsData);
                    }
                    if(index > 2 && index <=4){
                        if (index == 3) {
                            netOtherIncome.pBalance += item.pBalance;
                            netOtherIncome.balance += item.balance;
                        }
                        if (index == 4){
                            netOtherIncome.pBalance -= item.pBalance;
                            netOtherIncome.balance -= item.balance;
                        }
                        
                        netOtherIncomeColumnsData.push(itemColumnsDataCopy)
                    }
                    if (index == 4) {
                        var netOtherIncomeColumnsDataCopy = angular.copy(netOtherIncomeColumnsData);
                        netOtherIncome.columnsData = reduceData(netOtherIncomeColumnsDataCopy, true);
                        netIncomeColumnsData.push(netOtherIncome.columnsData)
                        var netIncomeColumnsDataCopy = angular.copy(netIncomeColumnsData)
                        netIncome.pBalance += netOtherIncome.pBalance;
                        netIncome.balance += netOtherIncome.balance;
                        netIncome.columnsData = reduceData(netIncomeColumnsDataCopy, false);
                    }
                    //item.columnsData = [];
                    //item.charts = [];
                    return item;
                });

                var matCogs = $filter('filter')($scope.testIncomeSheets[1].charts, {
                    detailType: 'Material-COGS'})[0]

                $scope.materialCOGSCurrentTotal = matCogs.ctotalBalance;
                $scope.materialCOGSPreviousTotal = $scope.othersListOfPaymentAccounts['Material-COGS'];

                $scope.setIncomeSheetReport();
            });
        }

        /**
         * Generate Income Report
         */
        $scope.setIncomeSheetReport = function(retainEarning) {
            $scope.isFetchedReport = true;
            $scope.incomeSheets = angular.copy(accountingConstant.incomeSheets); 
            let startDate = angular.copy($scope.startDate);
            let endDate = angular.copy($scope.endDate);
            let compareToDate = compareToDateRange($scope.startDate, $scope.endDate);
            let changeShowAs = $scope.selFilter.changeAs != 'None' ? $scope.selFilter.changeAs : null;
            var columnCount = 1;
            dynamicColumn(startDate, endDate, columnCount, compareToDate, changeShowAs)

            let searchProperties = {
                clientAccountId: $scope.main_accountId,
                detailsTypes: $scope.incomeTypes,
                reportType: balanceSheet,
                selectedRanges: [$scope.startDate, $scope.endDate],
                compareToRanges: compareToDate,
                accountMethod: $scope.accountMethod
            };

            TransactionService.query(searchProperties, function (transaction) { 
                const cTransactins = angular.copy(transaction[0].present) || [];
                const pTransactins = angular.copy(transaction[0].pasts) || [];
                var columnDataWithZero = [];
                var grossProfit = { name : 'Gross Profit', columnsData: [], balance:0, pBalance:0 },
                        netOperatingIncome = {name : 'Net Operating Income', columnsData: [], balance:0, pBalance:0 },
                        netOtherIncome = {name : 'Net Other Income', columnsData: [], balance:0, pBalance:0 },
                        netIncome = {name : 'Net Income', columnsData: [], balance:0, pBalance:0},
                        grossProfitColumnsData = grossProfit.columnsData,
                        netOperatingIncomeColumnsData = netOperatingIncome.columnsData,
                        netOtherIncomeColumnsData = netOtherIncome.columnsData,
                        netIncomeColumnsData = netIncome.columnsData;
                $scope.incomeSheets.map(function(item, index) {
                    item['columnsData'] = [];
                    var itemColumnsData = item['columnsData'];
                    var charts = angular.copy(balanceSheetChartList[item.name]);
                    if (charts && charts.length) {
                        charts = charts || [];
                        item['charts'] = angular.copy(charts);
                        chartBalance(item['charts'], cTransactins, pTransactins, changeShowAs, itemColumnsData, true, retainEarning);
                        item['charts'].map(function(chart) {
                            item.balance += chart.ctotalBalance;
                            item.pBalance += chart.ptotalBalance;
                        })
                    } else {
                        itemColumnsData.push(angular.copy($scope.columnDates));
                    }
                    var itemColumnsDataCopy = angular.copy(itemColumnsData);
                    item['columnsData'] = reduceData(itemColumnsDataCopy, false);
                    var columnDataZero = item.columnsData.filter(function(item) {
                        return item.type == 'current' && item.totals == 0
                    })
                    if (columnDataZero) {
                        var rootindex = columnDataZero.map(function(item){
                            return item.root;
                        })
                        columnDataWithZero = columnDataWithZero.concat(rootindex);
                    }
                    if(index > 0) {
                        removeIndex = _.filter(columnDataWithZero, (val, i, iteratee) => _.includes(iteratee, val, i + 1));
                        columnDataWithZero = angular.copy(removeIndex);
                    }
                    itemColumnsDataCopy = angular.copy(item['columnsData'])
                    if (index <= 1 ) {
                        if(index == 0) {
                            grossProfit.pBalance += item.pBalance;
                            grossProfit.balance += item.balance;
                        }
                        grossProfitColumnsData.push(itemColumnsDataCopy);
                    }
                    if (item.name === 'Cost Of Goods Sold') {
                        var grossProfitColumnsDataCopy = angular.copy(grossProfitColumnsData)
                        grossProfit.columnsData = reduceData(grossProfitColumnsDataCopy, true);
                        grossProfit.pBalance -= item.pBalance;
                        grossProfit.balance -= item.balance;
                        netOperatingIncome.pBalance += grossProfit.pBalance;
                        netOperatingIncome.balance += grossProfit.balance;
                        netOperatingIncomeColumnsData.push(grossProfit.columnsData);
                    }
                    if (index == 2 ) {
                        netOperatingIncomeColumnsData.push(itemColumnsDataCopy);
                        var netOperatingIncomeColumnsDataCopy = angular.copy(netOperatingIncomeColumnsData)
                        netOperatingIncome.columnsData = reduceData(netOperatingIncomeColumnsDataCopy, true);
                        netOperatingIncome.pBalance -= item.pBalance;
                        netOperatingIncome.balance -= item.balance;
                        netIncome.pBalance += netOperatingIncome.pBalance;
                        netIncome.balance += netOperatingIncome.balance;
                        netIncomeColumnsData.push(netOperatingIncome.columnsData);
                    }
                    if(index > 2 && index <=4){
                        if (index == 3) {
                            netOtherIncome.pBalance += item.pBalance;
                            netOtherIncome.balance += item.balance;
                        }
                        if (index == 4){
                            netOtherIncome.pBalance -= item.pBalance;
                            netOtherIncome.balance -= item.balance;
                        }
                        
                        netOtherIncomeColumnsData.push(itemColumnsDataCopy)
                    }
                    if (index == 4) {
                        var netOtherIncomeColumnsDataCopy = angular.copy(netOtherIncomeColumnsData);
                        netOtherIncome.columnsData = reduceData(netOtherIncomeColumnsDataCopy, true);
                        netIncomeColumnsData.push(netOtherIncome.columnsData)
                        var netIncomeColumnsDataCopy = angular.copy(netIncomeColumnsData)
                        netIncome.pBalance += netOtherIncome.pBalance;
                        netIncome.balance += netOtherIncome.balance;
                        netIncome.columnsData = reduceData(netIncomeColumnsDataCopy, false);
                    }
                    return item;
                });
                // removeIndex = _.filter(columnDataWithZero, (val, i, iteratee) => _.includes(iteratee, val, i + 1));
                grossProfit.columnsData = childPercentage(grossProfit.columnsData, grossProfit.columnsData);
                netOperatingIncome.columnsData = childPercentage(netOperatingIncome.columnsData, netOperatingIncome.columnsData);
                netOtherIncome.columnsData = childPercentage(netOtherIncome.columnsData, netOtherIncome.columnsData);
                netIncome.columnsData = childPercentage(netIncome.columnsData, netIncome.columnsData);

                if ($scope.columnSelection === 'nonZero' && $scope.selectedTabs !== balanceSheet) {
                    grossProfit.columnsData = removeZeroTotal(grossProfit.columnsData);
                    netOperatingIncome.columnsData = removeZeroTotal(netOperatingIncome.columnsData);
                    netOtherIncome.columnsData = removeZeroTotal(netOtherIncome.columnsData);
                    netIncome.columnsData = removeZeroTotal(netIncome.columnsData);
                }
                $scope.grossProfit = grossProfit;
                $scope.netOperatingIncome = netOperatingIncome;
                $scope.netOtherIncome = netOtherIncome;
                if (!!retainEarning) {
                    $scope.netRetainEarning = angular.copy(netIncome);
                } else {
                    $scope.netIncome = angular.copy(netIncome);
                }
                $scope.incomeSheets.map(function(item, index){
                    var itemColumnsData = angular.copy(item['columnsData']);
                    item['charts'].map(function(chart) {
                        var chartColumnsData = angular.copy(chart.columnsData);
                        if (chart.childItem && chart.childItem.length) {
                            chart.childItem.map(child1 =>{
                                if (child1.childItem.length) {
                                    child1.childItem.map(child2 =>{
                                        if (child2.childItem.length) {
                                            child2.childItem.map(child3 =>{
                                                if (child3.childItem.length) {
                                                    child3.childItem.map(child4 => {
                                                        if (child4.childItem.length) {
                                                            if ($scope.rowSelection === 'nonZero') {
                                                                child4.childItem = child4.childItem.filter(function(chart){
                                                                    return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                                });
                                                            }
                                                        }
                                                    })
                                                    if ($scope.rowSelection === 'nonZero') {
                                                        child3.childItem = child3.childItem.filter(function(chart){
                                                            return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                        });
                                                    }
                                                }
                                        
                                            })
                                            if ($scope.rowSelection === 'nonZero') {
                                                child2.childItem = child2.childItem.filter(function(chart){
                                                    return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                                });
                                            }
                                        }
                                    })
                                    if ($scope.rowSelection === 'nonZero') {
                                        child1.childItem = child1.childItem.filter(function(chart){
                                            return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                        });
                                    }
                                }
                            })
                            if ($scope.rowSelection === 'nonZero') {
                                chart.childItem = chart.childItem.filter(function(chart){
                                    return chart.ctotalBalance !== 0 || chart.ptotalBalance !== 0;
                                });
                            }
                        }

                        chart.columnsData = childPercentage(itemColumnsData, chartColumnsData);
                        if ($scope.columnSelection === 'nonZero'){
                            var chartColumnsDataCopy = angular.copy(chart.columnsData);
                            chart.columnsData = removeZeroTotal(chartColumnsDataCopy);
                        }
                        return chart;
                    })
                    if ($scope.rowSelection === 'nonZero') {
                        item['charts'] = item['charts'].filter(function(item){
                            return item.ctotalBalance !== 0 || item.ptotalBalance !== 0;
                        })
                    }
                    item['columnsData'] = childPercentage(itemColumnsData, itemColumnsData);
                    if ($scope.columnSelection === 'nonZero'){
                        var itemColumnsDataCopy = angular.copy(item['columnsData']);
                        item['columnsData'] = removeZeroTotal(itemColumnsDataCopy);
                    }
                    return item
                })
                if ($scope.selectedTabs === balanceSheet) {
                    $scope.showSpinner = true;
                    if(!retainEarning) {
                        $scope.setIncomeSheetReport(true)
                        $timeout($scope.setBalanceSheetReport,0);
                    }
                }
                $scope.showSpinner = false;
            });
        }

        $scope.pdfTableStructure = function (data) {
            var columnWidth = [];
            var marginLeft = 0;
            var totalWidth = 0;
            var tableBodyData = [];
            if($scope.selectedTabs === generalLedger) {
                columnWidth = [100, 60, 75, 60, 75, 75, 75, 75, 70];
                marginLeft = 15;
                tableBodyData = $scope.generalLedgerBody(data);
            } else if($scope.selectedTabs === 'balanceSheet' || $scope.selectedTabs === 'incomeStatus') {
                _.each(data[0]['columnsData'], function(data2, index) {
                    if(index === 0) {
                        columnWidth.push(120);
                        columnWidth.push(100);
                        totalWidth += 220;

                    } else {
                        columnWidth.push(100);
                        totalWidth += 100;
                    }  
                });
                marginLeft = ((842 - totalWidth) / 2);

                tableBodyData = $scope.selectedTabs === 'balanceSheet'
                    ?  $scope.balanceSheetBody(data)
                        : $scope.profitLossBody(data);
            }

            return [{
                layout: 'lightHorizontalLines',
                margin: [marginLeft, 0, 0, 0], 
                table: {
                    headerRows: 1,
                    widths: columnWidth,
                    body: tableBodyData
                },
                fontSize: 9
            }];
        }

        $scope.generalLedgerBody = function (data) {
            var body = [];
            body.push($scope.generalLedgerHeadings);
            _.each(data, function (row) {

                body.push([{ text: row.name, bold: true } ,"","","","","","","", '$ '+ row['openingBalance'].toFixed(2)]);

                _.each(row.transactions, function (transaction) {
                    var dataRow = [''];
                    var date = moment(transaction.date).format('MM/DD/YYYY');
                    dataRow.push(date);
                    dataRow.push(transaction.transactionType);
                    var name = transaction.payee ? transaction.payee.name
                        : transaction.user ? transaction.user.name
                            : transaction.customer ? transaction.customer.name : '-';
                    dataRow.push(name ? name : '-');
                    dataRow.push(transaction.referenceNo ? transaction.referenceNo : '');
                    dataRow.push(transaction.memo ? transaction.memo : '');
                    var accountName = transaction.transactionReport.length > 1 ? 'Account Split'
                        : transaction.transactionReport.length ? transaction.transactionReport[0].name
                            : '';
                    dataRow.push(accountName ? accountName : ''); 
                    dataRow.push(transaction.amount ? '$ ' + transaction.amount.toFixed(2) : '$ 0.00');
                    dataRow.push(transaction.balance ? '$ ' + transaction.balance.toFixed(2) : '$ 0.00');
                    body.push(dataRow);
                });
                var totalB = row.totalAmount ? '$ ' + row.totalAmount.toFixed(2) : '$ 0.00';
                body.push([{ text: 'Total for ' + row.name, bold: true } ,"","","","","","", totalB , ""]);
            });

            return body;
        };

        $scope.balanceSheetBody = function (data) {

            var body = []
            var defaultCols = [];
            var onlyColumns = [];
            _.each(data[0]['columnsData'], function(data, index) {
                if(index === 0) {
                    defaultCols.push({ text: 'Account Name', bold: true });
                    defaultCols.push({ text: data.title, bold: true });
                } else {
                    defaultCols.push({ text: data.title, bold: true });
                }
                onlyColumns.push('');
            });
            body.push(defaultCols);

            _.each(data, function (row) {

                var deColumns = angular.copy(onlyColumns); 
                deColumns.unshift({ text: row.name, bold: true })
                body.push(deColumns);

                _.each(row.childs, function (item) {

                    var deColumns2 = angular.copy(onlyColumns);
                    deColumns2.unshift({ text: item.name, bold: true, margin:[10,0,0,0] });
                    body.push(deColumns2);
                    if (!!item.charts && item.charts.length){
                        _.each(item.charts, function (chart) {
                            var dataRow = [{ text: chart.name, margin:[30,0,0,0] }];
                            dataRow = $scope.getPDFColumn(dataRow, chart.columnsData);
                            body.push(dataRow);
                            getChildItemsData(chart, body, 30);
                        });
                    }

                    _.each(item.types, function (type) {

                        var deColumns3 = angular.copy(onlyColumns);
                        deColumns3.unshift({ text: type.name, bold: true, margin:[20,0,0,0] });
                        body.push(deColumns3);
                        _.each(type.charts, function (chart) {
                            var dataRow = [{ text: chart.name, margin:[30,0,0,0] }];
                            dataRow = $scope.getPDFColumn(dataRow, chart.columnsData);
                            body.push(dataRow);
                            getChildItemsData(chart, body, 30);
                        });
                        _.each(type.types, function (type2) {

                            var deColumns4 = angular.copy(onlyColumns);
                            deColumns4.unshift({ text: type2.name, bold: true, margin:[20,0,0,0] });
                            body.push(deColumns4);
    
                            _.each(type2.charts, function (chart) {
                                var dataRow = [{ text: chart.name, margin:[30,0,0,0] }];
                                dataRow = $scope.getPDFColumn(dataRow, chart.columnsData);
                                body.push(dataRow);
                                getChildItemsData(chart, body, 30);
                            });
    
                            var deColumnsTotal4 = [];
                            deColumnsTotal4.push({ text: 'Total ' + type2.name, bold: true, margin:[20,0,0,5] });
                            deColumnsTotal4 = $scope.getPDFColumn(deColumnsTotal4, type2.columnsData);
                            body.push(deColumnsTotal4);
                            
                        });

                        var deColumnsTotal3 = [];
                        deColumnsTotal3.push({ text: 'Total ' + type.name, bold: true, margin:[20,0,0,5] });
                        deColumnsTotal3 = $scope.getPDFColumn(deColumnsTotal3, type.columnsData);
                        body.push(deColumnsTotal3);
                        
                    });

                    var deColumnsTotal2 = [];
                    deColumnsTotal2.push({ text: 'Total ' + item.name, bold: true, margin:[10,0,0,5] });
                    deColumnsTotal2 = $scope.getPDFColumn(deColumnsTotal2, item.columnsData);
                    body.push(deColumnsTotal2);
                });

                var deColumnsTotal1 = [];
                deColumnsTotal1.push({ text: 'Total ' + row.name, bold: true, margin:[0,0,0,5] });
                deColumnsTotal1 = $scope.getPDFColumn(deColumnsTotal1, row.columnsData);
                body.push(deColumnsTotal1);
            });

            return body;
        }

       function getChildItemsData (chartItm, rows, margin) {
            if (!!chartItm.childItem && chartItm.childItem.length) {
                let newMargin = margin + 10;
                for(let i=0; i < chartItm.childItem.length; i++) {
                    let dataRow = [{ text: chartItm.childItem[i].name, margin:[newMargin,0,0,0] }];
                    dataRow = $scope.getPDFColumn(dataRow, chartItm.childItem[i].columnsData);
                    rows.push(dataRow);
                    getChildItemsData(chartItm.childItem[i], rows, newMargin);
                }
            } else {
                return rows;
            }
        }

        $scope.profitLossBody = function (data) {
            var body = []
            var defaultCols = [];
            var onlyColumns = [];
            _.each(data[0]['columnsData'], function(data, index) {
                if(index === 0) {
                    defaultCols.push({ text: 'Account Name', bold: true });
                    defaultCols.push({ text: data.title, bold: true });
                } else {
                    defaultCols.push({ text: data.title, bold: true });
                }
                onlyColumns.push('');
            });
            body.push(defaultCols);

            _.each(data, function (row) {

                var deColumns1 = angular.copy(onlyColumns);
                deColumns1.unshift({ text: row.name, bold: true, margin:[0,0,0,0] });
                body.push(deColumns1);

                _.each(row.charts, function (chart) {
                    var dataRow = [{ text: chart.name, margin:[20,0,0,0] }];
                    dataRow = $scope.getPDFColumn(dataRow, chart.columnsData);
                    body.push(dataRow);
                    getChildItemsData(chart, body, 20);
                });

                var deColumnsTotal1 = [];
                deColumnsTotal1.push({ text: 'Total ' + row.name, bold: true, margin:[10,0,0,5] });
                deColumnsTotal1 = $scope.getPDFColumn(deColumnsTotal1, row.columnsData);
                body.push(deColumnsTotal1);

                if(row.name === 'Cost Of Goods Sold') {
                    var grossProfit = [];
                    grossProfit.push({ text: $scope.grossProfit.name, bold: true, margin:[0,0,0,5] });
                    grossProfit = $scope.getPDFColumn(grossProfit, $scope.grossProfit.columnsData);
                    body.push(grossProfit);
                }

                if(row.name  === 'Expenses') {
                    var netOperatingIncome = [];
                    netOperatingIncome.push({ text: $scope.netOperatingIncome.name, bold: true, margin:[0,0,0,5] });
                    netOperatingIncome = $scope.getPDFColumn(netOperatingIncome, $scope.netOperatingIncome.columnsData);
                    body.push(netOperatingIncome);
                }

                if(row.name  === 'Other Expenses') {
                    var netOtherIncome = [];
                    netOtherIncome.push({ text: $scope.netOtherIncome.name, bold: true, margin:[0,0,0,5] });
                    netOtherIncome = $scope.getPDFColumn(netOtherIncome, $scope.netOtherIncome.columnsData);
                    body.push(netOtherIncome);
                }

                if(row.name  === 'Other Expenses') {
                    var netIncome = [];
                    netIncome.push({ text: $scope.netIncome.name, bold: true, margin:[0,0,0,5] });
                    netIncome = $scope.getPDFColumn(netIncome, $scope.netIncome.columnsData);
                    body.push(netIncome);
                }
            });

            return body;
        }

        $scope.getPDFColumn = function(dataRow, data) {
            _.each(data, function (column) {
                if(column.type == 'percentage' || column.type == 'percChange') {
                    dataRow.push({ text: column.totals.toFixed(2) + '%', bold: true})
                } else {
                    dataRow.push({ text: '$' + column.totals.toFixed(2), bold: true});
                }
            });
            return dataRow;
        }

        $scope.genralLedgerCSV = function(data) {
            var str = $scope.generalLedgerHeadingsCSV.join(',');
            str += '\r\n';
            _.each(data, function (row) {
                    str += row.name + ',"","","","","","","",' + '$ '+ row['openingBalance'].toFixed(2);
                    str += '\r\n';
                _.each(row.transactions, function (transaction) {
                    var dataRow = [''];
                    var date = moment(transaction.date).format('MM/DD/YYYY');
                    dataRow.push(date);
                    dataRow.push(transaction.transactionType);
                    var name = transaction.payee ? transaction.payee.name
                        : transaction.user ? transaction.user.name
                            : transaction.customer ? transaction.customer.name : '-';
                    dataRow.push(name ? name : '-');
                    dataRow.push(transaction.referenceNo ? transaction.referenceNo : '');
                    dataRow.push(transaction.memo ? transaction.memo : '');
                    var accountName = transaction.transactionReport.length > 1 ? 'Account Split'
                        : transaction.transactionReport.length ? transaction.transactionReport[0].name
                            : '';
                    dataRow.push(accountName ? accountName : ''); 
                    dataRow.push(transaction.amount ? '$' + transaction.amount.toFixed(2) : '$0.00');
                    dataRow.push(transaction.balance ? '$' + transaction.balance.toFixed(2) : '$0.00');
                    str += dataRow.join(',')
                    str += '\r\n';
                });

                str += 'Total for ' + row.name + ',"","","","","","",'; 
                str += row.totalAmount ? '$ ' + row.totalAmount.toFixed(2) : '$ 0.00' + ',';
                str += '';
                str += '\r\n';

            });
            return str;
        }

        $scope.balanceSheetCSV = function(data) {
            var defaultCols = [];
            var onlyColumns = [];

            _.each($scope.balanceSheets[0]['columnsData'], function(data1, index) {
                if(index === 0) {
                    defaultCols.push('Account Name');
                    defaultCols.push(data1.title.replace(',', ' '));
                } else {
                    defaultCols.push(data1.title.replace(',', ' '));
                }
                onlyColumns.push('');
            });

            var str = defaultCols.join(',');
            str += '\r\n';

            _.each(data, function (row) {

                var deColumns = angular.copy(onlyColumns); 
                deColumns.unshift(row.name.replace(',', ' '));
                str += deColumns.join(',');
                str += '\r\n';

                _.each(row.childs, function (item) {

                    var deColumns2 = angular.copy(onlyColumns);
                    deColumns2.unshift(item.name.replace(',', ' '));
                    str += deColumns2.join(',');
                    str += '\r\n';

                    if (!!item.charts && item.charts.length) {
                        _.each(item.charts, function (chart) {
                            var dataRow = [chart.name.replace(',', ' ')];
                            dataRow = $scope.getCSVColumn(dataRow, chart.columnsData);
                            str += dataRow.join(',');
                            str += '\r\n';
                            var data =  { str: ''};
                            $scope.getChildItemsCsv(chart, data);
                            str += data.str;
                        });
                    }

                    _.each(item.types, function (type) {

                        var deColumns3 = angular.copy(onlyColumns);
                        deColumns3.unshift(type.name.replace(',', ' '));
                        str += deColumns3.join(',');
                        str += '\r\n';

                        _.each(type.charts, function (chart) {
                            var dataRow = [chart.name.replace(',', ' ')];
                            dataRow = $scope.getCSVColumn(dataRow, chart.columnsData);
                            str += dataRow.join(',');
                            str += '\r\n';
                            var data =  { str: ''};
                            $scope.getChildItemsCsv(chart, data);
                            str += data.str;
                        });

                        _.each(type.types, function (type2) {

                            var deColumns4 = angular.copy(onlyColumns);
                            deColumns4.unshift(type2.name.replace(',', ' '));
                            str += deColumns4.join(',');
                            str += '\r\n';

                            _.each(type2.charts, function (chart) {
                                var dataRow = [chart.name.replace(',', ' ')];
                                dataRow = $scope.getCSVColumn(dataRow, chart.columnsData);
                                str += dataRow.join(',');
                                str += '\r\n';
                                var data =  { str: ''};
                                $scope.getChildItemsCsv(chart, data);
                                str += data.str;
                            });

                            var deColumnsTotal4 = [];
                            deColumnsTotal4.push('Total ' + type2.name.replace(',', ' '));
                            deColumnsTotal4 = $scope.getCSVColumn(deColumnsTotal4, type2.columnsData);
                            str += deColumnsTotal4.join(',');
                            str += '\r\n';

                        })

                        var deColumnsTotal3 = [];
                        deColumnsTotal3.push('Total ' + type.name.replace(',', ' '));
                        deColumnsTotal3 = $scope.getCSVColumn(deColumnsTotal3, type.columnsData);
                        str += deColumnsTotal3.join(',');
                        str += '\r\n';
                        
                    });

                    var deColumnsTotal2 = [];
                    deColumnsTotal2.push('Total ' + item.name.replace(',', ' '));
                    deColumnsTotal2 = $scope.getCSVColumn(deColumnsTotal2, item.columnsData);
                    str += deColumnsTotal2.join(',');
                    str += '\r\n';
                });

                var deColumnsTotal1 = [];
                deColumnsTotal1.push('Total ' + row.name.replace(',', ' '));
                deColumnsTotal1 = $scope.getCSVColumn(deColumnsTotal1, row.columnsData);
                str += deColumnsTotal1.join(',');
                str += '\r\n';
            });

            return str;
        }


        $scope.getChildItemsCsv = function (chartItm, data) {
            if(!!chartItm.childItem && chartItm.childItem.length) {
                for(let i=0; i < chartItm.childItem.length; i++) {
                    var dataRow = [chartItm.childItem[i].name.replace(',', ' ')];
                    dataRow = $scope.getCSVColumn(dataRow, chartItm.childItem[i].columnsData);
                    data.str += dataRow.join(',');
                    data.str += '\r\n';
                    $scope.getChildItemsCsv(chartItm.childItem[i], data);
                }
            } else {
                return data;
            }
        }

        $scope.profitLossSheetCSV = function(data) {
            var defaultCols = [];
            var onlyColumns = [];

            _.each(data[0]['columnsData'], function(data1, index) {
                if(index === 0) {
                    defaultCols.push('Account Name');
                    defaultCols.push(data1.title.replace(',', ' '));
                } else {
                    defaultCols.push(data1.title.replace(',', ' '));
                }
                onlyColumns.push('');
            });

            var str = defaultCols.join(',');
            str += '\r\n';

            _.each(data, function (row) {

                var deColumns = angular.copy(onlyColumns); 
                deColumns.unshift(row.name.replace(',', ' '));
                str += deColumns.join(',');
                str += '\r\n';

                _.each(row.charts, function (chart) {
                    var dataRow = [chart.name.replace(',', ' ')];
                    dataRow = $scope.getCSVColumn(dataRow, chart.columnsData);
                    str += dataRow.join(',');
                    str += '\r\n';

                    var data =  { str: ''};
                    $scope.getProfitLossItemCsv(chart, data);
                    str += data.str;
                });

                var deColumnsTotal1 = [];
                deColumnsTotal1.push('Total ' + row.name.replace(',', ' '));
                deColumnsTotal1 = $scope.getCSVColumn(deColumnsTotal1, row.columnsData);
                str += deColumnsTotal1.join(',');
                str += '\r\n';

                if(row.name === 'Cost Of Goods Sold') {
                    var grossProfit = [];
                    grossProfit.push($scope.grossProfit.name.replace(',', ' '));
                    grossProfit = $scope.getCSVColumn(grossProfit, $scope.grossProfit.columnsData);
                    str += grossProfit.join(',');
                    str += '\r\n';
                }

                if(row.name  === 'Expenses') {
                    var netOperatingIncome = [];
                    netOperatingIncome.push($scope.netOperatingIncome.name.replace(',', ' '));
                    netOperatingIncome = $scope.getCSVColumn(netOperatingIncome, $scope.netOperatingIncome.columnsData);
                    str += netOperatingIncome.join(',');
                    str += '\r\n';
                }

                if(row.name  === 'Other Expenses') {
                    var netOtherIncome = [];
                    netOtherIncome.push($scope.netOtherIncome.name.replace(',', ' '));
                    netOtherIncome = $scope.getCSVColumn(netOtherIncome, $scope.netOtherIncome.columnsData);
                    str += netOtherIncome.join(',');
                    str += '\r\n';
                }

                if(row.name  === 'Other Expenses') {
                    var netIncome = [];
                    netIncome.push($scope.netIncome.name.replace(',', ' '));
                    netIncome = $scope.getCSVColumn(netIncome, $scope.netIncome.columnsData);
                    str += netIncome.join(',');
                    str += '\r\n';
                }
            });

            return str;
        }

        $scope.getProfitLossItemCsv = function (chartItm, data) {
            if(chartItm.childItem.length) {
                for(let i=0; i < chartItm.childItem.length; i++) {
                    var dataRow = [chartItm.childItem[i].name.replace(',', ' ')];
                    dataRow = $scope.getCSVColumn(dataRow, chartItm.childItem[i].columnsData);
                    data.str += dataRow.join(',');
                    data.str += '\r\n';
                    $scope.getProfitLossItemCsv(chartItm.childItem[i], data);
                }
            } else {
                return data;
            }
        }

        $scope.getCSVColumn = function(dataRow, data) {
            _.each(data, function (column) {
                if(column.type == 'percentage' || column.type == 'percChange') {
                    dataRow.push(column.totals.toFixed(2) + '%')
                } else {
                    dataRow.push('$' + column.totals.toFixed(2));
                }
            });
            return dataRow;
        }
    
        $scope.exportFile = function() {
            var fileName;
            var dataUrl = 'data:text/csv;utf-8,';
            if ($scope.selectedTabs === generalLedger) {
                dataUrl += encodeURI($scope.genralLedgerCSV($scope.accountsList));
                fileName  = 'genral-ledger-report.csv';
            } else if ($scope.selectedTabs === balanceSheet) {
                dataUrl += encodeURI($scope.balanceSheetCSV($scope.balanceSheets));
                fileName  = 'balance-sheet-report.csv'
            } else if ($scope.selectedTabs === incomeStatus) {
                dataUrl += encodeURI($scope.profitLossSheetCSV($scope.incomeSheets));
                fileName  = 'profit-and-loss-report.csv';
            }

            var link = document.createElement('a');
            angular.element(link)
                .attr('href', dataUrl)
                .attr('download', fileName); 
            link.click();
        };

        $scope.buildPDF = function () {

            var tableData , fileName, header_title, sub_header, emailMessage;
            var companyName = $scope.companyName;
            var pageOri = 'landscape';

            sub_header = ' As Of ' + moment($scope.startDate).format('MMM DD, YYYY - ');
            sub_header +=  moment($scope.endDate).format('MMM DD, YYYY');

            emailMessage = 'Report on the ' + moment().format('MMM DD, YYYY.');

            if ($scope.selectedTabs === generalLedger) {
                header_title = 'General Ledger Report';
                tableData = $scope.pdfTableStructure($scope.accountsList);
                fileName  = 'genral-ledger-report.pdf';
            } else if ($scope.selectedTabs === balanceSheet) {
                header_title = 'Balance Sheet Report';
                tableData = $scope.pdfTableStructure($scope.balanceSheets);
                fileName  = 'balance-sheet-report.pdf';
            } else if ($scope.selectedTabs === incomeStatus) {
                header_title = 'Profit & Loss Report';
                tableData = $scope.pdfTableStructure($scope.incomeSheets);
                fileName  = 'profit-and-loss-report.pdf';
            } else {
                return;
            }

            emailMessage += '<br/><br/>' + header_title + sub_header;
            emailMessage += '<br/>' + 'Please find your report is attached.<br/><br/>';

            var pdfDataBody = {
                pageMargins: [10, 20, 10, 20],
                pageSize: 'A4',
                Roboto: {
                    normal: 'Roboto-Regular.ttf',
                    bold: 'Roboto-Medium.ttf',
                    italics: 'Roboto-Italic.ttf',
                    bolditalics: 'Roboto-Italic.ttf'
                },
                header: [],
                pageOrientation: pageOri,
                content: [
                    {
                        alignment: 'center',
                        margin: [0, 0, 0, 10],
                        text: companyName,
                        style: 'company'
                    },
                    {
                        alignment: 'center',
                        margin: [0, 0, 0, 10],
                        text: header_title,
                        style: 'header'
                    },
                    {
                        alignment: 'center',
                        margin: [0, 0, 0, 10],
                        text: sub_header,
                        style: 'subHeader'
                    },
                    tableData,
                    ' ',
                    ' '
                ],
                styles: {
                    company: {
                        fontSize: 15,
                        bold: true
                    },
                    header: {
                      fontSize: 12,
                      bold: true
                    },
                    subHeader: {
                        fontSize: 10,
                        bold: true
                    }
                },
                defaultStyle: {
                    font: 'Roboto'
                }
            }

            if ($scope.just_print) {
                pdfMake.createPdf(pdfDataBody).open();
                $scope.just_print = false;
            } else {

                pdfMake.createPdf(pdfDataBody).getBase64(function (buffer) {
                    var data = ({
                        to: $scope.senderEmail.join(','),
                        from: header_title,
                        subject: header_title,
                        message: emailMessage + 
                                 '<b/><br/>This report is created using A.C.E. Construction Software.<br>' +
                                 'Please do not reply to this email and contact the contractor ' +
                                 'if you have any questions.',
                        fileName: fileName,
                        attachment: buffer
                    });

                    $http.post('/api/sendReports', data).
                        success(function () {
                            toaster.pop('success', 'Message was successfully sent');
                        }).
                        error(function () {
                            toaster.pop('error', 'There was an error with the message');
                    });
                });
            }
        };

        $scope.printList = function () {
            $scope.just_print = true;
            $scope.buildPDF();
        }

        $scope.searchReport = function () {
            if ($scope.selectedTabs === generalLedger) {
                $scope.showSpinner = true;
                $scope.setGeneralLedgerReport();
            }
            if ($scope.selectedTabs === balanceSheet) {
                $scope.showSpinner = true;
                $scope.setIncomeSheetReport();
            }
            if ($scope.selectedTabs === incomeStatus) {
                $scope.showSpinner = true;
                if($scope.accountMethod == 'Cash' && $scope.currentTab == 'Reports' && $scope.selectedTabs == incomeStatus)
                    $scope.setExtraIncomeSheetReport();
                else
                    $scope.setIncomeSheetReport();
            }
        };

        $scope.expand = function (index, state) {
            $scope.accountsList[index].isExpand = state;
        }
    
        $scope.onSelect = function (tab) {
            $scope.selectedTabs = tab;
            $scope.isFetchedReport = false;
            $scope.checkExportOption();
        }

        $scope.emailPopup = function () {
            $scope.senderEmail = [''];
            ngDialog.openConfirm({
                template: 'accounting/views/reports/modals/emails.html',
                scope: $scope,
                className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg',
                width: 400
            }).then(function(emails) {
                if(emails.length) {
                    $scope.just_print = false;
                    $scope.buildPDF();
                }
            }, function () {
                $scope.senderEmail = [];
            });
        }

        $scope.addMoreEmails = function () {
            $scope.senderEmail.push('');
        }

        $scope.removeEmails = function (index) {
            $scope.senderEmail.splice(index, 1);
        }

        $scope.getTotalsText = function(column, charName) {
            var retText = '';
            if(charName == 'Material-COGS')
                $scope.materialCOGSCashTotal = column.totals;
            if(column.type === 'current'
            || column.type === 'compare'
            || column.type === 'amountChange') {
                retText = $filter('currency')(column.totals,'$', 2);
                
            } else {
                if(!!column.totals) {
                    retText = $filter('number')(column.totals, 2) + ' %';
                }
            }
            return retText;
        }

        $scope.getRangeText = function(column) {
            if(!column.dates) return '';
            var retText = moment(column.dates.start).format("MMM DD, YYYY")
            retText += ' - ' + moment(column.dates.end).format("MMM DD, YYYY");
            return retText;
        }

        function totalPercentage(startDate, endDate, percentage, compareToDate, changeShowAs, selFilter) {
            var indexCount = 1;
            var columns= [{ title: dateLabel(startDate, endDate),
                type: 'current', dates: { start: moment(startDate).startOf('day'), end: moment(endDate).endOf('day')},
                root: indexCount,
                totals: 0
            }];
            var rootIndex = JSON.parse(JSON.stringify(indexCount));
            indexCount++;

            // percentage column
            if (percentage) {
                var newCol = { title: 'Totals (%)',
                    type: 'percentage',
                    root: rootIndex,
                    index: indexCount,
                    totals: 0
                };
                columns.push(newCol);
                indexCount++;
            }

            // compare to column
            if(changeShowAs !== null && compareToDate.length == 2){
                var compShortLabel = (selFilter === 'Previous Period') ? ' (PP)'
                    : (selFilter === 'Previous Year') ? ' (PY)' : ' (YD)';
                var newCol = { title: dateLabel(compareToDate[0], compareToDate[1]) + compShortLabel,
                    type: 'compare', root: rootIndex,
                    dates: { start: moment(compareToDate[0]).startOf('day'), end: moment(compareToDate[1]).endOf('day')},
                    index: indexCount++,
                    totals: 0
                };
                columns.push(newCol);
                indexCount++;
            }

            // change as column
            if(changeShowAs !== null && compareToDate.length == 2) {

                var newCol = { title: 'Change ($)',
                    type: 'amountChange',  root: rootIndex,
                    index: indexCount,
                    totals: 0
                };
                indexCount++;

                var newCol2 = { title: 'Change (%)', 
                    type: 'percChange', root: rootIndex,
                    index: indexCount,
                    totals: 0
                };
                indexCount++;

                if(changeShowAs == '$ Change') {
                    columns.push(newCol);
                } else if(changeShowAs == '% Change') {
                    columns.push(newCol2);
                } else {
                    columns.push(newCol);
                    columns.push(newCol2);
                }
            }

            return columns;
        }

        function weekRange(startDate, weekEndDate, index, count, ranges, columnCount, compare, showAs, percentage, compOption) {
            let dayNumber = moment(startDate).days();
            let remaning = (7-dayNumber);
            if (moment(startDate) <= moment(weekEndDate)) {
                let endDate = moment(startDate).add(remaning, 'days').endOf('day').format();
                if (moment(endDate) >= weekEndDate) {
                    endDate = weekEndDate.format();
                }
                let rDates = {
                    title: dateLabel(startDate, endDate),
                    type: 'current',
                    root: index,
                    dates: { start: moment(startDate).startOf('day').format(), end: endDate },
                    totals: 0
                };
                let rootIndex = JSON.parse(JSON.stringify(index));
                index++;
                ranges.push(rDates);

                // percentage column
                if (percentage) {
                    let newCol = { title: 'Totals (%)',
                        type: 'percentage',
                        root: rootIndex,
                        index: index,
                        totals: 0
                    };
                    ranges.push(newCol);
                    index++;
                }

                // compare to column
                
                if(showAs !== null && compare.length == 2) {
                    let compareToDates = {
                        start: moment(compare[0]).startOf('day'),
                        end: moment(compare[1]).endOf('day')
                    };
                    var sortName = compOption === 'Previous Period' ? ' (PP)' : compOption === 'Previous Year' ? ' (PY)' : ' (YTD)';
                    if(compOption === 'Previous Period' || compOption === 'Previous Year' ) {
                        let compDate = JSON.parse(JSON.stringify(startDate));
                        let compDate1 = JSON.parse(JSON.stringify(endDate));
                        compareToDates = {
                            start: moment(compDate).subtract(7, 'days').startOf('day'),
                            end: moment(compDate).subtract(1, 'days').endOf('day')
                        }
                        if (compOption === 'Previous Year') {
                            compareToDates.start = moment(compDate).subtract(1, 'years');
                            compareToDates.end = moment(compDate1).subtract(1, 'years');
                        }
                    }

                    let newCol = { title: dateLabel(compareToDates.start, compareToDates.end) + sortName,
                        type: 'compare', root: rootIndex,
                        dates: compareToDates,
                        index: index++,
                        totals: 0
                    };
                    ranges.push(newCol);
                    index++;

                }

                // change as column
                if(showAs !== null && compare.length == 2) {

                    if(showAs == '$ Change' || showAs == '$ & % Change') {
                        let newCol = { title: 'Change ($)',
                            type: 'amountChange',  root: rootIndex,
                            index: index,
                            totals: 0
                        };
                        index++;
                        ranges.push(newCol);
                    }
                    if(showAs == '% Change' || showAs == '$ & % Change') {
                        let newCol = { title: 'Change (%)', 
                            type: 'percChange', root: rootIndex,
                            index: index,
                            totals: 0
                        };
                        index++;
                        ranges.push(newCol);
                    }
                }

                let nextEndDate = moment(JSON.parse(JSON.stringify(endDate)));
                    nextEndDate = moment(nextEndDate).add(1, 'days');
                    count++;
                return weekRange(nextEndDate, weekEndDate, index, count, ranges, columnCount, compare, showAs, percentage, compOption);
            } else {
                return ranges;
            }
        }

        function monthRange(startDate, monthEndDate, index, count, ranges, firstMonth, columnCount, compare, showAs, percentage, compOption) {
            let dayNumber = moment(startDate).date();
            let monthDays = moment(startDate).daysInMonth();
            let remaning = moment(startDate).daysInMonth();
            if(firstMonth) {
                remaning = (monthDays - dayNumber);
            } else {
                remaning = (remaning -1); 
            }
            if (moment(startDate) <= moment(monthEndDate)) {
                let endDate = moment(startDate).add(Math.abs(remaning), 'days').format();
                if (moment(endDate) >= monthEndDate) {
                    endDate = monthEndDate.format();
                }
                let rDates = { 
                    title: dateLabel(startDate, endDate),
                    type: 'current',
                    root: index,
                    dates: { start: moment(startDate).format(), end: endDate },
                    totals: 0
                };
                let rootIndex = JSON.parse(JSON.stringify(index));
                index++;
                
                ranges.push(rDates);

                // percentage column
                if (percentage) {
                    let newCol = { title: 'Totals (%)',
                        type: 'percentage',
                        root: rootIndex,
                        index: index,
                        totals: 0
                    };
                    ranges.push(newCol);
                    index++;
                }

                // compare to column
                if(showAs !== null && compare.length == 2){
                    let compareToDates = {
                        start: moment(compare[0]).startOf('day'),
                        end: moment(compare[1]).endOf('day')
                    };
                    var sortName = compOption === 'Previous Period' ? ' (PP)' : compOption === 'Previous Year' ? ' (PY)' : ' (YTD)';
                    if(compOption === 'Previous Period' || compOption === 'Previous Year' ) {
                        let compDate = JSON.parse(JSON.stringify(startDate));
                        let compDate1 = JSON.parse(JSON.stringify(endDate));
                        if (compOption === 'Previous Period') {
                            compareToDates = {
                                start: moment(compDate).subtract(1, 'months').startOf('day'),
                                end: moment(compDate).subtract(1, 'days').endOf('day')
                            }
                        }
                       
                        if (compOption === 'Previous Year') {
                            compareToDates.start = moment(compDate).subtract(1, 'years');
                            compareToDates.end = moment(compDate1).subtract(1, 'years');
                        }
                    }
                    let newCol = { title: dateLabel(compareToDates.start, compareToDates.end) + sortName,
                        type: 'compare', root: rootIndex,
                        dates: compareToDates,
                        index: index++,
                        totals: 0
                    };
                    ranges.push(newCol);
                    index++;
                }

                // change as column
                if(showAs !== null && compare.length == 2) {

                    if(showAs == '$ Change' || showAs == '$ & % Change') {
                        let newCol = { title: 'Change ($)',
                            type: 'amountChange',  root: rootIndex,
                            index: index,
                            totals: 0
                        };
                        index++;
                        ranges.push(newCol);
                    }
                    if(showAs == '% Change' || showAs == '$ & % Change') {
                        let newCol = { title: 'Change (%)', 
                            type: 'percChange', root: rootIndex,
                            index: index,
                            totals: 0
                        };
                        index++;
                        ranges.push(newCol);
                    }
                }

                let nextEndDate = moment(JSON.parse(JSON.stringify(endDate)));
                    nextEndDate = moment(nextEndDate).add(1, 'days');
                    count++;
                return monthRange(nextEndDate, monthEndDate, index, count, ranges, false, columnCount, compare, showAs, percentage, compOption);
            } else {
                return ranges;
            }
        }

        function quarterRange(startDate, quaterEndDate, index, count, ranges, firstMonth, columnCount, compare, showAs, percentage, compOption) {
            var fiscalYear = moment($scope.fiscalYear),
                fiscalYearDay = fiscalYear.date(),
                fiscalYearMonth = fiscalYear.month() + 1,
                fiscalYearYear = moment(startDate).year(),
                fiscalYear = moment(fiscalYearMonth + '/'+ fiscalYearDay + '/' + fiscalYearYear);
            if (moment(startDate) < fiscalYear ) {
                fiscalYear = fiscalYear.subtract(1, 'year');
            }
            var Q1S = fiscalYear,
                Q2S = moment(fiscalYear).add(3, 'month'),
                Q3S = moment(fiscalYear).add(6, 'month'),
                Q4S = moment(fiscalYear).add(9, 'month'),
                Q4E = moment(fiscalYear).add(12, 'month');
            
            if (moment(startDate) <= moment(quaterEndDate)) {
                let endDate, Qcount;

                if ((moment(startDate).isAfter(Q1S) || moment(startDate).isSame(Q1S)) &&  (moment(startDate).isBefore(Q2S) || moment(startDate).isSame(Q2S))){
                    endDate = Q2S.subtract(1, 'days').endOf('day').format();
                    Qcount = 'Q1';
                }
                if ((moment(startDate).isAfter(Q2S) || moment(startDate).isSame(Q2S)) &&  (moment(startDate).isBefore(Q3S) || moment(startDate).isSame(Q3S))){
                    endDate = Q3S.subtract(1, 'days').endOf('day').format();
                    Qcount = 'Q2';
                }
                if ((moment(startDate).isAfter(Q3S) || moment(startDate).isSame(Q3S)) &&  (moment(startDate).isBefore(Q4S) || moment(startDate).isSame(Q4S))){
                    endDate = Q4S.subtract(1, 'days').endOf('day').format();
                    Qcount = 'Q3';
                }
                if ((moment(startDate).isAfter(Q4S) || moment(startDate).isSame(Q4S)) &&  (moment(startDate).isBefore(Q4E) || moment(startDate).isSame(Q4E))){
                    endDate = Q4E.subtract(1, 'days').endOf('day').format();
                    Qcount = 'Q4';
                }
                if (moment(endDate) >= quaterEndDate) {
                    endDate = quaterEndDate.format();
                }
                let rDates = {
                    title: Qcount + ' ' + dateLabel(startDate, endDate),
                    type: 'current',
                    root: index,
                    dates: { start: moment(startDate).startOf('day').format(), end: endDate },
                    totals: 0
                };
                let rootIndex = JSON.parse(JSON.stringify(index));
                index++;
                ranges.push(rDates);
                // percentage column
                if (percentage) {
                    let newCol = { title: 'Totals (%)',
                        type: 'percentage',
                        root: rootIndex,
                        index: index,
                        totals: 0
                    };
                    ranges.push(newCol);
                    index++;
                }

                // compare to column
                if (showAs !== null && compare.length == 2){
                    
                    let compareToDates = {
                        start: moment(compare[0]).startOf('day'),
                        end: moment(compare[1]).endOf('day')
                    };
                    var sortName = compOption === 'Previous Period' ? ' (PP)' : compOption === 'Previous Year' ? ' (PY)' : ' (YTD)';
                    if (compOption === 'Previous Period' || compOption === 'Previous Year' ) {
                        let compDate = JSON.parse(JSON.stringify(startDate));
                        let compDate1 = JSON.parse(JSON.stringify(endDate));
                        if (compOption === 'Previous Period') {
                            compareToDates = {
                                start: moment(compDate).subtract(3, 'months').startOf('day'),
                                end: moment(compDate).subtract(1, 'days').endOf('day')
                            }
                        }
                        if (compOption === 'Previous Year') {
                            compareToDates.start = moment(compDate).subtract(1, 'years');
                            compareToDates.end = moment(compDate1).subtract(1, 'years');
                        }
                    }
                    let newCol = { title: dateLabel(compareToDates.start, compareToDates.end) + sortName,
                        type: 'compare', root: rootIndex,
                        dates: compareToDates,
                        index: index++,
                        totals: 0
                    };
                    ranges.push(newCol);
                    index++;
                }

                // change as column
                if (showAs !== null && compare.length == 2) {

                    if (showAs == '$ Change' || showAs == '$ & % Change') {
                        let newCol = { title: 'Change ($)',
                            type: 'amountChange',  root: rootIndex,
                            index: index,
                            totals: 0
                        };
                        index++;
                        ranges.push(newCol);
                    }
                    if (showAs == '% Change' || showAs == '$ & % Change') {
                        let newCol = { title: 'Change (%)', 
                            type: 'percChange', root: rootIndex,
                            index: index,
                            totals: 0
                        };
                        index++;
                        ranges.push(newCol);
                    }
                }

                let nextEndDate = angular.copy(endDate);
                nextEndDate = moment(nextEndDate).add(1, 'days');
                count++;
                return quarterRange(nextEndDate, quaterEndDate, index, count, ranges, false, columnCount, compare, showAs, percentage, compOption);
            } else {
                return ranges;
            }
        }

        function generateNextColumn(chartData, compareTo, changeShowAs, income, retainEarning) {
            var fiscalYear = moment($scope.fiscalYear),
            fiscalYearDay = fiscalYear.date(),
            fiscalYearMonth = fiscalYear.month() + 1;

            chartData.columnsData = angular.copy($scope.columnDates);
            // calculate total and percentage of total
            var currentBalance = 0,
                previousBalance = 0;
            _.each(chartData.columnsData, function(singleColumn, indexNo) {
               
                if (singleColumn.type === 'current') {
                    // calculate $ totals
                    var columnBalance = 0;
                    _.each(chartData.cTransaction, function(transaction) {
                        var date = moment(transaction.date),
                            singleColumnStartDate = moment(singleColumn.dates.start),
                            singleColumnEndDate = moment(singleColumn.dates.end),
                            fiscalYearYear = singleColumnEndDate.year();

                            fiscalYear = moment(fiscalYearMonth + '/'+ fiscalYearDay + '/' + fiscalYearYear);
                            if (singleColumnStartDate <= fiscalYear && singleColumnEndDate <= fiscalYear) {
                                fiscalYear = fiscalYear.subtract(1, 'year');
                            }
                        var TransactionDateCond = !!income && !retainEarning ? (date.isAfter(moment(fiscalYear)) || date.isSame(moment(fiscalYear)))
                        && (date.isBefore(moment(singleColumnEndDate)) ||  date.isSame(moment(singleColumnEndDate))) :
                        !!income && !!retainEarning ? date.isBefore(moment(fiscalYear)) ||  date.isSame(moment(fiscalYear)) :
                        (date.isBefore(moment(singleColumnEndDate)) ||  date.isSame(moment(singleColumnEndDate)));
                        
                        if (TransactionDateCond) {
                            if (transaction.type === 'credit') {
                                columnBalance +=  (transaction.debitIncrease ?  Number(-transaction.paymentAmount) : Number(transaction.paymentAmount));
                            } else {
                                columnBalance += (transaction.debitIncrease ? Number(transaction.expenseAmount) : Number(-transaction.expenseAmount));
                            }
                        }
                    });
                    singleColumn.totals = columnBalance;
                    currentBalance = columnBalance;
                    
                }
                if (compareTo !== 'None') {
                    if (singleColumn.type === 'compare') {
                        var columnBalance = 0;
                        _.each(chartData.cTransaction, function(transaction) {
                            var date = moment(transaction.date),
                                singleColumnStartDate = moment(singleColumn.dates.start),
                                singleColumnEndDate = moment(singleColumn.dates.end),
                                fiscalYearYear = singleColumnEndDate.year();
                            fiscalYear = moment(fiscalYearMonth + '/'+ fiscalYearDay + '/' + fiscalYearYear);
                            if (singleColumnStartDate <= fiscalYear && singleColumnEndDate <= fiscalYear) {
                                fiscalYear = fiscalYear.subtract(1, 'year');
                            }
                            
                        var TransactionDateCond1 = !!income && !retainEarning ? (date.isAfter(moment(fiscalYear)) || date.isSame(moment(fiscalYear)))
                        && (date.isBefore(moment(singleColumnEndDate)) ||  date.isSame(moment(singleColumnEndDate))) :
                        !!income && !!retainEarning ? date.isBefore(moment(fiscalYear)) ||  date.isSame(moment(fiscalYear)) :
                        (date.isBefore(moment(singleColumnEndDate)) ||  date.isSame(moment(singleColumnEndDate)));
                            if (TransactionDateCond1) {
                                if(transaction.type == 'credit') {
                                    columnBalance += (transaction.debitIncrease ?  Number(-transaction.paymentAmount) : Number(transaction.paymentAmount));
                                } else {
                                    columnBalance += (transaction.debitIncrease ? Number(transaction.expenseAmount) : Number(-transaction.expenseAmount));
                                }
                            }
                        });
                        chartData.columnsData[indexNo].totals = columnBalance;
                        previousBalance = columnBalance
                    }
                }
            });
            chartData.ctotalBalance = currentBalance;
            chartData.ptotalBalance = previousBalance;
            return chartData;
        }

        function ChangePercentage(current, previous) {
            return ((current - previous)/previous)*100;
        }

        function percentage(current, total) {
            return (current/total)*100;
        }

        function dateLabel(date1, date2) {
            let dateString = '';
            if(moment(date1).year() === moment(date2).year()) {
                if(moment(date1).month() === moment(date2).month()) {
                    dateString = moment(date1).format('MMM DD-') + moment(date2).format('DD, YYYY');
                } else {
                    dateString = moment(date1).format('MMM DD - ') + moment(date2).format('MMM DD, YYYY');
                }
                
            } else {
                if(moment(date1).month() === moment(date2).month()) {
                    dateString = moment(date1).format('MMM DD-') + moment(date2).format('DD, ') + moment(date1).format('YYYY-') + moment(date2).format('YYYY');
                } else {
                    dateString = moment(date1).format('MMM DD - ') + moment(date2).format('MMM DD, ') + moment(date1).format('YYYY-') + moment(date2).format('YYYY');
                }
            }
            return dateString;
        }
}]);



// WEBPACK FOOTER //
// ./packages/custom/accounting/public/controllers/reports.js